import Student1 from "../pages/HomePage/assets/student1.png";
import Student2 from "../pages/HomePage/assets/student2.png";
import Student3 from "../pages/HomePage/assets/student3.png";
import Student4 from "../pages/HomePage/assets/student4.png";
import Student5 from "../pages/HomePage/assets/student5.png";
import Student6 from "../pages/HomePage/assets/student6.png";
import Student7 from "../pages/HomePage/assets/student7.png";
import Student8 from "../pages/HomePage/assets/student8.png";
import Student10 from "../pages/HomePage/assets/student10.png";
import DuTimes from "../pages/HomePage/assets/du_times.svg";
import Company5 from "../pages/HomePage/assets/company5.svg";
import Company3 from "../pages/HomePage/assets/company3.svg";
import Company6 from "../pages/HomePage/assets/company6.svg";
import Company8 from "../pages/HomePage/assets/company8.svg";
import Company10 from "../pages/HomePage/assets/company10.svg";
import Company7 from "../pages/HomePage/assets/company7.svg";
import Company1 from "../pages/HomePage/assets/groupm.svg";
import Company2 from "../pages/HomePage/assets/billeasy.svg";
import Signup from "../pages/HomePage/assets/signup.png";
import QuizComplete from "../pages/HomePage/assets/quiz.png";
import CourseUnlocked from "../pages/HomePage/assets/unlockMskill.png";
import CompleteMskill from "../pages/HomePage/assets/mskillComplete.png";
import completemskil1day from "../pages/HomePage/assets/completemskill1day.png";

const Constants = {
  Mixpanel: {
    LOG_IN: "Log In",
    PHONE_NUMBER_VERIFIED: "Phone Number Verified",
    /* Landing Page Events */
    LANDING_PAGE_VISIT: "Landing Page Visit",

    //
    LANDING_PAGE_LOGIN_WITH_GOOGLE_CLICKED:
      "Landing Page Login With Google Clicked",
    LANDING_PAGE_LOGIN_WITH_EMAIL_CLICKED:
      "Landing Page Login With Email Clicked",
    LANDING_PAGE_LOGIN_WITH_LINKEDIN_CLICKED:
      "Landing Page Login With LinkedIn Clicked",
    LANDING_PAGE_LOGIN_WITH_FACEBOOK_CLICKED:
      "Landing Page Login With Facebook Clicked",
    LANDING_PAGE_SIGNUP_WITH_EMAIL_CLICKED:
      "Landing Page Signup With Email Clicked",
    ONBOARDING_STEP_ONE: "Onboarding Step 1",
    ONBOARDING_STEP_TWO: "Onboarding Step 2",
    ONBOARDING_STEP_THREE: "Onboarding Step 3",
    ONBOARDING_STEP_FOUR: "Onboarding Step 4",
    ONBOARDING_STEP_FIVE: "Onboarding Step 5",
    /* Home Page Events */
    HOMEPAGE_VISIT: "Home Page Visit",
    CONTINUE_LEARNING_CLICK: "Continue Learning Click",
    CONTINUE_LEFT_OFF_CLICK: "Continue Left Off Click",
    LOOK_UP_SKILL_CLICK: "Look Up Skill Click",
    BECAUSE_ENROLLED_CLICK: "Because You Enrolled Click",
    FEATURED_SKILL_CLICK: "Featured Skill Click",
    REQUEST_COURSE_SUBMIT: "Request Course Submit",
    BECAUSE_YOU_SEARCHED_FOR: "Because You Searched Click",
    BASED_ON_YOUR_SEARCH: "Based On Your Search Click",
    MOST_VIEWED_SKILL: "Most Viewed Skill Click",
    MOST_VIEWED_MICRO_SKILL: "Most Viewed Micro Skill Click",
    OUR_TOP_PICK_CLICK: "Our Top Pick Click",
    COURSES_TO_GET_STARTED: "Courses To Get Started Click",
    /* Skill Page Events */
    SKILL_LISTING_PAGE_VISIT: "Skill Listing Page Visit",
    SKILL_ENROLLED: "Skill Enrolled",
    /* Microskill Page Events */
    MICROSKILL_LISTING_PAGE_VISIT: "Micro-Skill Listing Page Visit",
    /* Content Player Events */
    CONTENT_PLAYER_VISIT: "Content Player Visit",
    VIDEO_LESSON_STARTED: "Video Lesson Started",
    QUIZ_ATTEMPT: "Quiz Question Attempted",
    QUIZ_COMPLETE: "Quiz Completed",
    NOTES_CLICK: "Notes Click (Player)",
    DOUBTS_CLICK: "Doubts Click (Player)",
    RELATED_CLICK: "Related Click (Player)",
    VIDEO_PLAYER_PLAY: "Video Lesson Played",
    VIDEO_PLAYER_PAUSE: "Video Lesson Paused",
    /* Dropdown clicks */
    DROPDOWN_COURSE_CLICK: "Dropdown Course Click",
    DROPDOWN_SKILL_CLICK: "Dropdown Skill Click",
    /* Mobile Sidebar Clicks */
    MB_SIDEBAR_COURSE_CLICK: "Mobile Sidebar Course Click",
    MB_SIDEBAR_SKILL_CLICK: "Mobile Sidebar Skill Click",
    /* Certificate Actions */
    CERTIFICATE_DOWNLOAD_CLICK: "Certificate Download Clicked",
    /* Profile Page */
    PROFILE_PAGE_VISIT: "Profile Page Visit",
    /* Mega Menu */
    MEGA_MENU_CLICK: "Mega Menu Click",
    /* Footer */
    START_PREMIUM_CLICK: "Start Premium Click",
    /* Market Place */
    MARKET_PLACE_VISIT: "Market Place Page Visit",
    /* Banner CTA Clicks */
    AD_BANNER_CLICK: "Ad Banner CTA Click",
    // Pricing Page Clicks
    PRICING_PAGE_VISIT: "Visited Pricing Page",
    PURCHASED_COINS: "Purchased Coins",
    PURCHASED_SUBSCRIPTION: "Purchased Subscription",

    CLICKED_LTPRO: "Clicked LT-Pro Button", //clicked on button
    CLICKED_LTPROPLUS: "Clicked LT-Pro Plus Button",
    CLICKED_LTX: "Clicked LT-X Button",
    CLICKED_LTMAX: "Clicked LT-Max Buttton",

    CLICKED_LTPRO_CARD: "Clicked LT-Pro Card", //clicked on card
    CLICKED_LTPROPLUS_CARD: "Clicked LT-Pro Plus Card",
    CLICKED_LTX_CARD: "Clicked LT-X Card",
    CLICKED_LTMAX_CARD: "Clicked LT-MAX Card",

    REQUESTED_HELP: "Clicked Career Request Help", //kholne pe hai
    CHECKED_ELIGIBILITY: "Checked Eligibility",

    ACCEPTED_CHALLENGE: "Accepted One-day Challenge",
    DECLINED_CHALLENGE: "Declined One-day Challenge",

    JOB_APPLIED: "Job Applied",
    PAYMENT_ATTEMPT: "Payment_Attempt",
    JOB_APPLICATION_ATTEMPT: "Job_Application_Attempt", //Available jobs
    JES_STARTED: "JES_STARTED",
    JES_CALCULATED: "JES Calculated",
    JES_ENTRY_NAVBAR_ICON: "JES Entry from navbar Icon",
    JES_ENTRY_MENU_ICON: "JES Entry from User menu",
    JES_ENTRY_NAVBAR_ICON: "JES Entry from navbar Icon",
    JES_ENTRY_CERTIFICATE_ICON: "JES Entry from Certificate section",

    SELECTED_LT_MAX_BOOSTER: "Clicked LT Max Booster",
    SELECTED_LT_X_BOOSTER: "Clicked LT x Booster",
    SELECTED_LT_PRO_BOOSTER: "Clicked LT pro Booster",

    WEEKLY_LEADERBOARD_TOGGLE: "WEEKLY_LEADERBOARD_TOGGLE",

    WALL_EXPLORE: "8D Wall- Explore",
    WALL_DOWNGRADE_1: "8D Wall- Downgrade 1",
    WALL_DOWNGRADE_2: "8D Wall- Downgrade 2",
    WALL_DOWNGRADE_3: "8D Wall- Downgrade 3",
    WALL_VISIT_OVERALL: "8D Wall- Visit",
    WALL_UNLOCK: "8D Wall- Unlock 299",
    WALL_EXPLORE_ALL: "8D Wall- ExploreAll",
    WALL_EXPLORE_MAX: "8D Wall- ExploreMax",
    WALL_DOWNGRADE_EXIT: "8D Wall- Downgrade Exit",
    WALL_VISIT_BOT: "8D Wall WA Visit",

    SHARE_CERTIFICATE_CLICKED: "Share_certificate_clicked",

    CHAT_WIDGET_CLICKED: "Chat Widget Clicked",
    CHAT_WIDGET_CLOSED: "Chat Widget Closed",

    HOME_PAGE_BANNER_1: "Home Page Banner 1 clicked",
    HOME_PAGE_BANNER_2: "Home Page Banner 2 clicked",

    // New Onboarding Page
    NEW_ONBOARDING_PAGE: "New Onboarding Page Loaded",
    NEW_ONBOARDING_PAGE_COURSE_SELECTED: "New Onboarding Page Course Selected",
    NEW_ONBOARDING_PAGE_SKILL_SELECTED: "New Onboarding Page Skill Selected",
    NEW_ONBOARDING_PAGE_CUSTOM_SKILL_SELECTED:
      "New Onboarding Page Custom Skill Selected",
    NEW_ONBOARDING_PAGE_GOAL_SELECTED: "New Onboarding Page Goal Selected",
    NEW_ONBOARDING_PAGE_ROLE_SELECTED: "New Onboarding Page Role Selected",
    NEW_ONBOARDING_PAGE_TIME_SELECTED: "New Onboarding Page Time Selected",
    NEW_ONBOARDING_PAGE_SKILL_LEVEL_SELECTED:
      "New Onboarding Page Skill Level Selected",
    NEW_ONBOARDING_PAGE_ODD_USER_PAGE:
      "New Onboarding Page Odd User Page Loaded",
    NEW_ONBOARDING_PAGE_ODD_USER_TOP_PERSONALISE_PAYMENT:
      "New Onboarding Page Odd User Page Top Payment Button Was Clicked",
    NEW_ONBOARDING_PAGE_ODD_USER_BOTTOM_PERSONALISE_PAYMENT:
      "New Onboarding Page Odd User Page Bottom Payment Button Was Clicked",
    NEW_ONBOARDING_PAGE_ODD_USER_TOP_NORMAL:
      "New Onboarding Page Odd User Page Top Normal Button Was Clicked",
    NEW_ONBOARDING_PAGE_ODD_USER_BOTTOM_NORMAL:
      "New Onboarding Page Odd User Page Bottom Normal Button Was Clicked",
    NEW_ONBOARDING_PAGE_EVEN_USER_PAGE:
      "New Onboarding Page Even User Page Loaded",

    // Personalise Flow
    PERSONALISE_PAGE_QUESTION_LOADER:
      "Personalise Page Question Loader Page Loaded",

    // Personalise Page Question Page Loaded
    PERSONALISE_PAGE_QUESTION: "Personalise Page Question Page Loaded",
    PERSONALISE_PAGE_QUESTION_1: "Personalise Page Question 1 Answered",
    PERSONALISE_PAGE_QUESTION_2: "Personalise Page Question 2 Answered",
    PERSONALISE_PAGE_QUESTION_3: "Personalise Page Question 3 Answered",
    PERSONALISE_PAGE_QUESTION_4: "Personalise Page Question 4 Answered",
    PERSONALISE_PAGE_QUESTION_5: "Personalise Page Question 5 Answered",
    PERSONALISE_PAGE_QUESTION_6: "Personalise Page Question 6 Answered",
    PERSONALISE_PAGE_QUESTION_7: "Personalise Page Question 7 Answered",
    PERSONALISE_PAGE_QUESTION_1_REANSWERED:
      "Personalise Page Question 1 Answered Again",
    PERSONALISE_PAGE_QUESTION_2_REANSWERED:
      "Personalise Page Question 2 Answered Again",
    PERSONALISE_PAGE_QUESTION_3_REANSWERED:
      "Personalise Page Question 3 Answered Again",
    PERSONALISE_PAGE_QUESTION_4_REANSWERED:
      "Personalise Page Question 4 Answered Again",
    PERSONALISE_PAGE_QUESTION_5_REANSWERED:
      "Personalise Page Question 5 Answered Again",
    PERSONALISE_PAGE_QUESTION_6_REANSWERED:
      "Personalise Page Question 6 Answered Again",
    PERSONALISE_PAGE_QUESTION_7_REANSWERED:
      "Personalise Page Question 7 Answered Again",
    PERSONALISE_PAGE_ANALYSIS_LOADER:
      "Personalise Page Analysis Loader Was Loaded",

    // Personalise Page Analysis
    PERSONALISE_PAGE_ANALYSIS: "Personalise Page Analysis Page Was Loaded",
    PERSONALISE_PAGE_ANALYSIS_TOP_PERSONALISE_PAYMENT:
      "Personalise Page Analysis Top Payment Button Was Clicked",
    PERSONALISE_PAGE_ANALYSIS_BOTTOM_PERSONALISE_PAYMENT:
      "Personalise Page Analysis Bottom Payment Button Was Clicked",
    PERSONALISE_PAGE_ANALYSIS_TOP_NORMAL:
      "Personalise Page Analysis Top Normal Button Was Clicked",
    PERSONALISE_PAGE_ANALYSIS_BOTTOM_NORMAL:
      "Personalise Page Analysis Bottom Normal Button Was Clicked",

    // Skip Button
    PERSONALISE_PAGE_SKIP: "Personalise Skip Button Was Clicked",

    // Skip Button Odd User
    ODD_USER_SKIP_BUTTON: "Odd User Skip Button Was Clicked",

    //Certificate Verification
    CERTIFICATE_PAGE_VISIT: "Certificate Verification Page Visited",
    BUILD_PERSONALISED_COURSE_BUTTON_CLICKED:
      "Certificate Verification Page Personalise button was Clicked",
    GET_CERTIFIED_BUTTON_CLICKED:
      "Certificate Verification Page Get Certified button was Clicked",
    TEST_AND_CERTIFIY_BUTTON_CLICKED:
      "Certificate Verification Page Test and Certify button was Clicked",
    COMPARE_YOUR_SCORE_BUTTON_CLICKED:
      "Certificate Verification Page Compare Your score button was Clicked",
    SUBMIT_BUTTON_CLICKED:
      "Certificate Verification Page Submit Button Clicked",
    BUILD_PERSONALISED_COURSE_BUTTON_CLICKED_FORM:
      "Certificate Verification Page Personalise button was Clicked from form",
    GET_CERTIFIED_BUTTON_CLICKED_FORM:
      "Certificate Verification Page Get Certified button was Clicked from form",

    CERTIFICATE_VERIFICATION_DEFAULT_PAGE_LOADED:
      "Certificate Verification Default Page was Loaded",
    CERTIFICATE_VERIFICATION_DEFAULT_VERIFY_CERTIFICATE_CLICKED:
      "Certificate Verification Default Verify Certificate button was Clicked",
    CERTIFICATE_VERIFICATION_DEFAULT_GET_CERTIFIED_CLICKED:
      "Certificate Verification Default Get Certified button was Clicked",
    CERTIFICATE_VERIFICATION_DEFAULT_BUILD_PERSONALIZED_COURSE_CLICKED:
      "Certificate Verification Default Build Personalised Course button was Clicked",
    CERTIFICATE_VERIFICATION_DEFAULT_EXPLORE_COURSES_CLICKED:
      "Certificate Verification Default Explore 1240 Courses button was Clicked",
    CERTIFICATE_VERFIICATION_DEFAULT_STICY_CTA_GET_CERTIFIED_CLICKED:
      "Certificate Verification Default Sticky CTA Get Certified button was Clicked",
    CERTIFICATE_VERIFICATION_DEFAULT_STICKY_CTA_BUILD_PERSONALIZED_COURSE_CLICKED:
      "Certificate Verification Default Sticky CTA Build Personalised Course button was Clicked",

    CERTIFICATE_VERIFICATION_FORM_LOADED:
      "Certificate Verification Form was Loaded",
    CERTIFICATE_VERIFICATION_FORM_CONTINUE_WITH_LINKEDIN_CLICKED:
      "Certificate Verification Form Continue with linkedin button was clicked",
    CERTIFICATE_VERIFICATION_FORM_VIEW_USER_CERTIFICATE_CLICKED:
      "Certificate Verification Form View User Certificate button was clicked",
    CERTIFICATE_VERIFICATION_FORM_GET_CERTIFIED_CLICKED:
      "Certificate Verification Form Get certified button was clicked",
    CERTIFICATE_VERIFICATION_FORM_BUILD_PERSONALIZED_COURSE_CLICKED:
      "Certificate Verification Form Build Personalise Course button was clicked",

    //
    CERTIFICATE_VERIFICATION_OWNER_PAGE_LOADED:
      "Certificate Verification Owner Page was Loaded",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_LIKE_BUTTON_CLICKED:
      "Certificate Verification Owner Page Like button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_SHARE_BUTTON_CLICKED:
      "Certificate Verification Owner Page Share button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_DOWNLOAD_BUTTON_CLICKED:
      "Certificate Verification Owner Page Download button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_COMMENT_COUNT_BUTTON_CLICKED:
      "Certificate Verification Owner Page Comment count button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_COMMENT_BUTTON_CLICKED:
      "Certificate Verification Owner Page Comment button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_VIEW_ALL_COMMENTS_BUTTON_CLICKED:
      "Certificate Verification Owner Page View All comments button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_UPLOAD_CV_AND_LINKEDIN_CLICKED:
      "Certificate Verification Owner Page Upload CV and LinkedIn button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_UPLOAD_CV_BUTTON_CLICKED:
      "Certificate Verification Owner Page Upload CV button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_REPLACE_CV_BUTTON_CLICKED:
      "Certificate Verification Owner Page Replace CV button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_LINKEDIN_PROFILE_SELECTED:
      "Certificate Verification Owner Page LinkedIn profile was selected",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_CV_AND_LINKEDIN_SUBMIT_BUTTON_CLICKED:
      "Certificate Verification Owner Page CV and LinkedIn submit button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_RECOMMENDED_SKILLS_PILL_CLICKED:
      "Certificate Verification Owner Page Recommended skills pill was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_GET_CERTIFIED_CLICKED:
      "Certificate Verification Owner Page Get Certified button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_BUILD_PERSONALIZED_COURSE_CLICKED:
      "Certificate Verification Owner Page Build Personalised Course button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_EDIT_BUTTON_CLICKED:
      "Certificate Verification Owner Page Edit button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_STICKY_CTA_GET_CERTIFIED_CLICKED:
      "Certificate Verification Owner Page Sticky CTA Get Certified button was clicked",
    CERTIFICATE_VERIFICATION_OWNER_PAGE_STICKY_CTA_BUILD_PERSONALIZED_COURSE_CLICKED:
      "Certificate Verification Owner Page Sticky CTA Build Personalised Course button was clicked",

    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_LOADED:
      "Certificate Verification Recruiter Page was Loaded",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_LIKE_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Like button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_SHARE_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Share button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_DOWNLOAD_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Download button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_COMMENT_COUNT_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Comment count button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_COMMENT_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Comment button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_VIEW_ALL_COMMENTS_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page View All comments button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_REQUEST_CV_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Request CV button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_REQUEST_INTERVIEW_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Request Interview button was clicked",

    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_REQUEST_CV_SUBMIT_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Request CV Submit button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_REQUEST_INTERVIEW_SUBMIT_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Request CV Interview button was clicked",

    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_CV_AND_LINKEDIN_SUBMIT_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page CV and LinkedIn submit button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_RECOMMENDED_SKILLS_PILL_CLICKED:
      "Certificate Verification Recruiter Page Recommended skills pill was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_GET_CERTIFIED_CLICKED:
      "Certificate Verification Recruiter Page Get Certified button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_BUILD_PERSONALIZED_COURSE_CLICKED:
      "Certificate Verification Recruiter Page Build Personalised Course button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_EXPLORE_1240_COURSES_CLICKED:
      "Certificate Verification Recruiter Page Explore 1240 Courses button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_EDIT_BUTTON_CLICKED:
      "Certificate Verification Recruiter Page Edit button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_STICKY_CTA_GET_CERTIFIED_CLICKED:
      "Certificate Verification Recruiter Page Sticky CTA Get Certified button was clicked",
    CERTIFICATE_VERIFICATION_RECRUITER_PAGE_STICKY_CTA_BUILD_PERSONALIZED_COURSE_CLICKED:
      "Certificate Verification Recruiter Page Sticky CTA Build Personalised Course button was clicked",

    CERTIFICATE_VERIFICATION_NORMAL_PAGE_LOADED:
      "Certificate Verification Normal Page was Loaded",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_LIKE_BUTTON_CLICKED:
      "Certificate Verification Normal Page Like button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_SHARE_BUTTON_CLICKED:
      "Certificate Verification Normal Page Share button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_DOWNLOAD_BUTTON_CLICKED:
      "Certificate Verification Normal Page Download button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_COMMENT_COUNT_BUTTON_CLICKED:
      "Certificate Verification Normal Page Comment count button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_COMMENT_BUTTON_CLICKED:
      "Certificate Verification Normal Page Comment button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_VIEW_ALL_COMMENTS_BUTTON_CLICKED:
      "Certificate Verification Normal Page View All comments button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_REQUEST_CV_SUBMIT_BUTTON_CLICKED:
      "Certificate Verification Normal Page Request CV submit button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_REQUEST_CV_BUTTON_CLICKED:
      "Certificate Verification Normal Page Request CV submit button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_GET_PERSONALIZED_PATH_CLICKED:
      "Certificate Verification Normal Page Get Personalised path was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_RECOMMENDED_SKILLS_PILL_CLICKED:
      "Certificate Verification Normal Page Recommended skills pill was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_GET_CERTIFIED_CLICKED:
      "Certificate Verification Normal Page Get Certified button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_BUILD_PERSONALIZED_COURSE_CLICKED:
      "Certificate Verification Normal Page Build Personalised Course button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_EDIT_BUTTON_CLICKED:
      "Certificate Verification Normal Page Edit button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_EXPLORE_1240_COURSES_CLICKED:
      "Certificate Verification Normal Page Explore 1240 Courses button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_STICKY_CTA_GET_CERTIFIED_CLICKED:
      "Certificate Verification Normal Page Sticky CTA Get Certified button was clicked",
    CERTIFICATE_VERIFICATION_NORMAL_PAGE_STICKY_CTA_BUILD_PERSONALIZED_COURSE_CLICKED:
      "Certificate Verification Normal Page Sticky CTA Build Personalised Course button was clicked",

    CERTIFICATE_VERIFICATION_PAGE_EDIT_FORM_LOADED:
      "Certificate Verification Edit Form was Loaded",
    CERTIFICATE_VERIFICATION_PAGE_EDIT_FORM_UPDATE_DETAILS_CLICKED:
      "Certificate Verification Edit Form Update Details button clicked",

    //Hompage
    CONTINUE_LEARNING_PERSONALIZE_CLICK:
      "Homepage Personalise Continue Learning Clicked",

    //course page
    COURSE_PAGE_LESSON_LIST_CLICKED: "Course Page lesson list clicked",
    COURSE_PAGE_INFO_CARD_CLICKED: "Course Page info card clicked",

    //LinkedIn share
    LINKEDIN_SHARE_CLICKED: "linkedin_share_clicked",
    LINKEDIN_SHARED: "linkedin_shared",

    // Recruiter Page
    RECRUITER_PAGE_LOADED: "Recruiter Page was Loaded",
    RECRUITER_DESKTOP_TOP_CTA_CLICKED:
      "Recruiter Page Desktop Footer CTA Clicked",
    RECRUITER_MAIN_HEADER_CTA_CLICKED: "Recruiter Page Main Header CTA Clicked",
    RECRUITER_CANDIDATES_SECTION_CTA_CLICKED:
      "Recruiter Page Candidates Section CTA Clicked",
    RECRUITER_FOOTER_CTA_CLICKED: "Recruiter Page Footer CTA Clicked",
    RECRUITER_PAGE_FORM_SUBMIT_CLICKED: "Recruiter Page Form Submit Clicked",

    // OnboardingPage25
    ONBOARDING_PAGE_25_FIRST_STEP_LOADED: "OnboardingPage25 First Step Loaded",
    ONBOARDING_PAGE_25_SECOND_STEP_LOADED:
      "OnboardingPage25 Second Step Loaded",
    ONBOARDING_PAGE_25_THIRD_STEP_LOADED: "OnboardingPage25 Third Step Loaded",
    ONBOARDING_PAGE_25_THIRD_STEP_CONTINUE_BUTTON_CLICKED:
      "OnboardingPage25 Third Step Continue Button Clicked",
    ONBOARDING_PAGE_25_FOURTH_STEP_LOADED:
      "OnboardingPage25 Fourth Step Loaded",
    ONBOARDING_PAGE_25_FOURTH_STEP_START_CAREER_JOURNEY_BUTTON_CLICKED:
      "OnboardingPage25 Fourth Step Start Career Journey Button Clicked",
    ONBOARDING_PAGE_25_FIFTH_STEP_LOADED: "OnboardingPage25 Fifth Step Loaded",
    ONBOARDING_PAGE_25_STEP_FIVE_DOMAIN_SELECTION_LOADED:
      "OnboardingPage25 Fifth Step Domain Selection Loaded",

    ONBOARDING_PAGE_25_CERTIFICATE_PAGE_LOADED:
      "OnboardingPage25 Certificate Page Loaded",
    ONBOARDING_PAGE_25_CERTIFICATE_PAGE_GET_MY_INSTANT_CERTIFICATE_BUTTON_CLICKED:
      "OnboardingPage25 Certificate Page Get My Instant Certificate Button Clicked",
    ONBOARDING_PAGE_25_CERTIFICATE_PAGE_LET_ME_TRY_FREE_STANDARD_COURSE_BUTTON_CLICKED:
      "OnboardingPage25 Certificate Page Let Me Try Free Standard Course Button Clicked",
    ONBOARDING_PAGE_25_CERTIFICATE_PAGE_LOADER_LOADED:
      "OnboardingPage25 Certificate Page Loader Loaded",

    ONBOARDING_PAGE_25_COURSE_PAGE_LOADED:
      "OnboardingPage25 Course Page Loaded",
    ONBOARDING_PAGE_25_COURSE_PAGE_GET_MY_PERSONALISED_COURSE_BUTTON_CLICKED:
      "OnboardingPage25 Course Page Get My Personalised Course Button Clicked",
    ONBOARDING_PAGE_25_COURSE_PAGE_LET_ME_TRY_FREE_STANDARD_COURSE_BUTTON_CLICKED:
      "OnboardingPage25 Course Page Let Me Try Free Standard Course Button Clicked",
    ONBOARDING_PAGE_25_COURSE_PAGE_LOADER_LOADED:
      "OnboardingPage25 Course Page Loader Loaded",
    ONBOARDING_PAGE_25_COURSE_PAGE_FREE_LOADER_LOADED:
      "OnboardingPage25 Course Page Free Loader Loaded",

    ONBOARDING_PAGE_25_JOB_PAGE_LOADED: "OnboardingPage25 Job Page Loaded",
    ONBOARDING_PAGE_25_JOB_PAGE_START_MY_JOB_PREP_NOW_BUTTON_CLICKED:
      "OnboardingPage25 Job Page Start My Job Prep Now Button Clicked",
    ONBOARDING_PAGE_25_JOB_PAGE_SEE_MY_JOB_READINESS_SCORE_BUTTON_CLICKED:
      "OnboardingPage25 Job Page See My Job Readiness Score Button Clicked",
    ONBOARDING_PAGE_25_JOB_PAGE_LOADER_LOADED:
      "OnboardingPage25 Job Page Loader Loaded",

    ONBOARDING_PAGE_25_CV_PAGE_LOADED: "OnboardingPage25 CV Page Loaded",
    ONBOARDING_PAGE_25_CV_PAGE_START_MY_CV_AND_PROFILE_BOOSTING_NOW_BUTTON_CLICKED:
      "OnboardingPage25 CV Page Start My CV And Profile Boosting Now Button Clicked",
    ONBOARDING_PAGE_25_CV_PAGE_SEE_MY_CV_HEALTH_SCORE_BUTTON_CLICKED:
      "OnboardingPage25 CV Page See My CV Health Score Button Clicked",
    ONBOARDING_PAGE_25_CV_PAGE_LOADER_LOADED:
      "OnboardingPage25 CV Page Loader Loaded",

    ONBOARDING_PAGE_25_PLACEMENT_SUPPORT_WEEK_MODAL_OPENED:
      "OnboardingPage25 Placement Support Week Modal Opened",

    ONBOARDING_PAGE_25_FIRST_STEP_CARD_CLICKED:
      "OnboardingPage25 First Step Card Clicked",
    ONBOARDING_PAGE_25_SECOND_STEP_CARD_CLICKED:
      "OnboardingPage25 Second Step Card Clicked",
    ONBOARDING_PAGE_25_FIFTH_STEP_CUSTOM_CARD_CLICKED:
      "OnboardingPage25 Fifth Step Custom Skill Card Clicked",
    ONBOARDING_PAGE_25_FIFTH_STEP_COURSE_CARD_CLICKED:
      "OnboardingPage25 Fifth Step Course Card Clicked",
    ONBOARDING_PAGE_25_FIFTH_STEP_SKILL_CARD_CLICKED:
      "OnboardingPage25 Fifth Step Skill Card Clicked",
    ONBOARDING_PAGE_25_FIFTH_EXPLORE_COURSES_BUTTON_CLICKED:
      "OnboardingPage25 Fifth Step Explore Courses Button Clicked",
    ONBOARDING_PAGE_25_BACK_BUTTON_CLICKED:
      "OnboardingPage25 Back Button Clicked",
    ONBOARDING_PAGE_25_FORWARD_BUTTON_CLICKED:
      "OnboardingPage25 Forward Button Clicked",

    ONBOARDING_PAGE_25_PREMIUM_BUTTONS_CLICKED:
      "OnboardingPage25 Premium Buttons Clicked",
    ONBOARDING_PAGE_25_LOADER_LOADED: "OnboardingPage25 Loader Loaded",

    ONBOARDING_PAGE_25_JOB_PAGE_SUBSCRIPTION_PURCHASED:
      "OnboardingPage25 Job Page Subscription Purchased",
    ONBOARDING_PAGE_25_CV_PAGE_SUBSCRIPTION_PURCHASED:
      "OnboardingPage25 CV Page Subscription Purchased",
    ONBOARDING_PAGE_25_COURSE_PAGE_SUBSCRIPTION_PURCHASED:
      "OnboardingPage25 Course Page Subscription Purchased",

    NUMBER_VERIFICATION25_PAGE_LOADED: "Number Verification25 Page Loaded",

    // Recruiter Feature
    RECRUITER_LANDING_PAGE_VISIT: "Recruiter Landing Page Loaded",
    RECRUITER_LANDING_PAGE_SEARCH_BUTTON_CLICKED:
      "Recruiter Landing Page Search Bar Clicked",
    RECRUITER_LANDING_PAGE_SEARCH_BUTTON_SUBMITTED:
      "Recruiter Landing Page Search Query Submitted",
    RECRUITER_LANDING_PAGE_FEATURED_LEADERBOARD_CLICKED:
      "Recruiter Landing Page Featured Leaderboard Clicked",
    RECRUITER_LANDING_PAGE_OTHER_LEADERBOARDS_CLICKED:
      "Recruiter Landing Page Other Leaderboards Clicked",
    RECRUITER_LANDING_PAGE_EXPLORE_LOCATION_CLICKED:
      "Recruiter Landing Page Explore Location Clicked",
    RECRUITER_LANDING_PAGE_FOOTER_SIGN_UP_CLICKED:
      "Recruiter Landing Page Footer Sign Up Clicked",
    RECRUITER_LANDING_PAGE_SIGNED_IN_MENU_CLICKED:
      "Recruiter Landing Page Signed In Menu Clicked",
    RECRUITER_RESULTS_PAGE_LOADED: "Recruiter Results Page Loaded",
    RECRUITER_RESULTS_PAGE_FILTER_REMOVED:
      "Recruiter Results Page Filter Removed",
    RECRUITER_RESULTS_PAGE_VIEW_FILTERS_CLICKED:
      "Recruiter Results Page View Filters Clicked",
    RECRUITER_RESULTS_PAGE_QUERY_RESET_CLICKED:
      "Recruiter Results Page Query Reset Clicked",
    RECRUITER_RESULTS_PAGE_SEE_MORE_CLICKED:
      "Recruiter Results Page See More Clicked",
    RECRUITER_RESULTS_PAGE_OTHER_LEADERBOARDS_CLICKED:
      "Recruiter Results Page Other Leaderboards Clicked",
    RECRUITER_RESULTS_PAGE_TOP_CANDIDATE_PROFILE_CARD_CLICKED:
      "Recruiter Results Page Top Candidate Profile Card Clicked",
    RECRUITER_RESULTS_PAGE_BOTTOM_CANDIDATE_PROFILE_CARD_CLICKED:
      "Recruiter Results Page Bottom Candidate Profile Card Clicked",
    RECRUITER_RESULTS_PAGE_BASIC_CANDIDATE_PROFILE_CARD_CLICKED:
      "Recruiter Results Page Basic Candidate Profile Card Clicked",
    RECRUITER_CANDIDATE_PROFILE_SHORTLIST_ADDED:
      "Recruiter Candidate Profile Shortlist Added",
    RECRUITER_CANDIDATE_PROFILE_SHORTLIST_REMOVED:
      "Recruiter Candidate Profile Shortlist Removed",
    RECRUITER_FILTER_DRAWER_X_CLICKED: "Recruiter Filter Drawer X Clicked",
    RECRUITER_FILTER_DRAWER_SKILLS_CLICKED:
      "Recruiter Filter Drawer Skills Clicked",
    RECRUITER_FILTER_DRAWER_COMPANIES_CLICKED:
      "Recruiter Filter Drawer Companies Clicked",
    RECRUITER_FILTER_DRAWER_INSTITUTIONS_CLICKED:
      "Recruiter Filter Drawer Institutions Clicked",
    RECRUITER_FILTER_DRAWER_CITIES_CLICKED:
      "Recruiter Filter Drawer Cities Clicked",
    RECRUITER_FILTER_DRAWER_EXPERIENCE_CLICKED:
      "Recruiter Filter Drawer Experience Clicked",
    RECRUITER_FILTER_DRAWER_APPLY_FILTERS_SUBMITTED:
      "Recruiter Filter Drawer Apply Filters Submitted",
    RECRUITER_FILTER_DRAWER_CLEAR_FILTERS_CLICKED:
      "Recruiter Filter Drawer Clear Filters Clicked",
    RECRUITER_FILTER_DRAWER_SEARCH_BAR_CLICKED:
      "Recruiter Filter Drawer Search Bar Clicked",
    RECRUITER_FILTER_DRAWER_SEARCH_QUERY_SUBMITTED:
      "Recruiter Filter Drawer Search Query Submitted",
    RECRUITER_SHORTLIST_PAGE_LOADED: "Recruiter Shortlist Page Loaded",
    RECRUITER_SHORTLIST_PAGE_CLICKED: "Recruiter Shortlist Page Clicked",
    RECRUITER_REQUEST_INTERVIEW_CLICKED: "Recruiter Request Interview Clicked",
    RECRUITER_DOWNLOAD_CV_CLICKED: "Recruiter Download CV Clicked",
    RECRUITER_AUTH_SUCCESS: "Recruiter Auth Success",
    RECRUITER_COMPLETE_PROFILE_SUCCESS: "Recruiter Complete Profile Success",
  },
};
export const API_ABLY_KEY =
  "kmbGlg.6hqOIg:A6_oYylROx14oDf2P0i8UD9NByDdhyYhdO70pPSAVYQ";

export const domains = [
  {
    id: 1,
    name: "Programming",
    course_slug: "programming-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Coding_1.svg?updatedAt=1688364023282",
    mskill_count: 749,
  },
  {
    id: 2,
    name: "Digital Marketing",
    course_slug: "digital-marketing-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Digital_Marketing_25.svg?updatedAt=1688364137460",
    mskill_count: 224,
  },
  {
    id: 3,
    name: "Data Science & Analytics",
    course_slug: "data-science-analytics-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Data_Science_1.svg?updatedAt=1688364191116",
    mskill_count: 305,
  },
  {
    id: 4,
    name: "Design, Art & Tools",
    course_slug: "design-art-tools-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Pencil_with_Ruler.svg?updatedAt=1688364239209",
    mskill_count: 412,
  },
  {
    id: 5,
    name: "Finance & Investments",
    course_slug: "finance-investments-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/finance_1.svg?updatedAt=1688364280208",
    mskill_count: 153,
  },
  {
    id: 6,
    name: "UI/UX",
    course_slug: "uiux-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/UI_UX_Design_1.svg?updatedAt=1688364322372",
    mskill_count: 82,
  },
  {
    id: 7,
    name: "Business & Management",
    course_slug: "business-management-courses",
    image:
      "https://img.learntube.ai/public-assets/LinkdinUsers/Business.svg?updatedAt=1701415944525",
    mskill_count: 244,
  },
  {
    id: 8,
    name: "Language",
    course_slug: "language-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Language_Translate_1.svg?updatedAt=1688364410223",
    mskill_count: 45,
  },
  {
    id: 9,
    name: "Cloud Computing",
    course_slug: "cloud-computing-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Cloud_Computing_1.svg?updatedAt=1688364460111",
    mskill_count: 123,
  },
  {
    id: 10,
    name: "Operating System and Databases",
    course_slug: "operating-system-and-databases-courses",
    image:
      "https://img.learntube.ai/public-assets/LinkdinUsers/Database.svg?updatedAt=1701415944394",
    mskill_count: 114,
  },
  {
    id: 11,
    name: "Hardware and Network Security",
    course_slug: "hardware-and-network-security-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Hardware_1.svg?updatedAt=1688364553384",
    mskill_count: 99,
  },
  {
    id: 12,
    name: "Film Making",
    course_slug: "film-making-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/film_making_1.svg?updatedAt=1688364620738",
    mskill_count: 76,
  },
  {
    id: 13,
    name: "Development Tools and No Code",
    course_slug: "development-tools-and-no-code-courses",
    image:
      "https://img.learntube.ai/public-assets/LinkdinUsers/No%20Code%20Development%20Platform.svg?updatedAt=1701416015216",
    mskill_count: 177,
  },
  {
    id: 14,
    name: "Web 3",
    course_slug: "web-3-courses",
    image:
      "https://img.learntube.ai/public-assets/LinkdinUsers/NFT%20technology.svg?updatedAt=1701416015062",
    mskill_count: 14,
  },
  {
    id: 15,
    name: "Music",
    course_slug: "music-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Music_Sign_1.svg?updatedAt=1688364728768",
    mskill_count: 82,
  },
];

export const verificationFaqs = [
  {
    id: 0,
    question: <div className="">Which companies value this certificate?</div>,
    answer: (
      <div>
        This certificate is valued by <b>over 1100+ top employers</b> — from{" "}
        <b>fast-growing startups</b> to <b>global MNCs</b>. It's built on
        LearnTube's <b>P.E.A.K.S. framework</b>, co-developed with experts from
        top 100 MNCS & Startups, and <b>recognised by Google</b>.
        <br />
        Over <b>12 lakh professionals and students</b> have used LearnTube
        certifications to <b>land interviews, promotions, and job offers</b>.
        <br />
        By sharing yours, you're showing you're{" "}
        <b>industry-ready and trusted by the best</b>.
      </div>
    ),
  },
  {
    id: 1,
    question: <div className="">How does sharing now 5X my job chances?</div>,
    answer: (
      <div>
        Sharing creates visibility where it matters. Recruiters scan LinkedIn
        for <b>recent, relevant achievements</b>, and a verified certificate
        leads to{" "}
        <b>
          more views, callbacks, shortlists, and a stronger presence in
          interviews
        </b>
        .
        <br />
        It tells hiring teams:{" "}
        <i>
          I'm not just certified — I'm proactive, upskilled, and ready to
          contribute
        </i>
        .
        <br />
        Further, <b>LinkedIn amplifies fresh achievements</b>. Sharing within 24
        hours boosts visibility.
      </div>
    ),
  },
  {
    id: 2,
    question: (
      <div className="">
        How does sharing on Instagram or WhatsApp boost my career?
      </div>
    ),
    answer: (
      <div>
        By sharing your achievements with <b>friends, colleagues, and alumni</b>{" "}
        — you are making your growth <b>visible</b> to the people who are most
        likely to refer or recommend you. You are building{" "}
        <b>top-of-mind recall</b>, leading to{" "}
        <b>referrals, role suggestions and direct DMs</b> about opportunities.
      </div>
    ),
  },
  {
    id: 5,
    question: (
      <div className="">
        What if I haven't updated my LinkedIn profile or don't have many
        connections?
      </div>
    ),
    answer: (
      <div>
        That's totally fine. Even if your network is small,{" "}
        <b>LinkedIn amplifies fresh certifications</b> — especially in the first
        24 hours to a wider network helping you add more connections.
        <br />
        <b>You will get noticed</b>, grow your network, and start showing up in
        recruiter searches — all without posting often.
      </div>
    ),
  },
  {
    id: 4,
    question: (
      <div className="">I’m not looking for a job - why share now?</div>
    ),
    answer: (
      <div>
        Even better. Sharing today helps you{" "}
        <b>build long-term professional presence</b>. It shows growth, boosts
        credibility in your network, and often leads to{" "}
        <b>unexpected referrals</b> or collaboration invites.
        <br />
        Your <b>future self will thank you</b> — when it's time to apply, your
        profile is already doing the talking.
      </div>
    ),
  },
  {
    id: 3,
    question: (
      <div className="">
        How does LearnTube guarantee 2X higher reach on sharing?
      </div>
    ),
    answer: (
      <div>
        LearnTube gives you a <b>1-click Share</b> with{" "}
        <b>professionally written text</b> designed and tested to get users{" "}
        <b>1200+ views on average</b> across{" "}
        <b>LinkedIn, Instagram and WhatsApp</b>.
        <br />
        Your post includes your <b>verified certificate, a link for proof</b>,
        and is ready to share on the most popular platforms — No guesswork, just{" "}
        <b>2X higher reach, great comments and reactions</b>.
      </div>
    ),
  },
  {
    id: 6,
    question: (
      <div className="">Will it look like I'm bragging if I share?</div>
    ),
    answer: (
      <div>
        Not at all. Sharing your growth isn't bragging — it's{" "}
        <b>professional signalling</b>.
        <br />
        Whether on LinkedIn, Instagram, or WhatsApp, you're not saying{" "}
        <b>"Look at me,"</b> you're saying{" "}
        <i>"I'm learning, growing, and showing up."</i> That's exactly the
        mindset respected in today's workforce — especially when continuous
        learning matters.
      </div>
    ),
  },
  {
    id: 7,
    question: (
      <div className="">What referral benefits do I get for sharing?</div>
    ),
    answer: (
      <div>
        When you share, your post includes a <b>referral link</b>.
        <br />
        If friends, colleagues, or family sign up using it,{" "}
        <b>both of you earn LearnTube credits</b> that can be used toward{" "}
        <b>courses, certifications, or exclusive rewards</b>. Your growth helps
        others grow too!
      </div>
    ),
  },
];

export const personalisationFaqs = [
  {
    id: 0,
    question: "How is this course personalised for me?",
    answer: `Our domain experts (with 30+ years of combined experience) along with our AI engine analyse your skills, goals & answers to identify what you need to learn. We then build a detailed syllabus accordingly for you. And the personalisation doesn't end here. Once you start learning, your course will be further personalised to you as per your needs.`,
  },
  {
    id: 1,
    question: "What all courses do you offer?",
    answer:
      "Our personalisation technology works across domains, from career skills like Java to even hobbies like baking. Most users use us to learn work related skills in the domain of Programming, Marketing, Data Science, Design, Business & lots of different tools.",
  },
  {
    id: 2,
    question: "Does the course really help in jobs?",
    answer:
      "Yess! If you learn properly, do your assessments & projects and then showcase your skills in your CV & portfolio to employers it will make a huge difference in your job applications & even your own confidence. Our learners work at top companies from Amazon to TCS and many have gone on to become freelancers & entrepreneurs.",
  },
  {
    id: 3,
    question: "Does LearnTube make the content too?",
    answer:
      "We make personalised, certified courses. We do not make the videos in the course. Those are sourced from across the internet to make sure we get the very best content for you. Most videos are from top YouTube creators. We do the hard work of figuring out what you need to learn, finding the very best videos for it, arranging it in the best order, assessing your skills, solving your doubts, giving you projects to do & then certifying you.",
  },
  {
    id: 4,
    question: "How do I get certified?",
    answer:
      "Once you complete the course & assessments you will get certified immediately. Our certificate is recognised by hundreds of companies.",
  },
  {
    id: 5,
    question: "Is there any refund policy?",
    answer:
      "There sure is. While completing your course, if you find a cheaper, more personalised course than ours you will get your money back! Just reach out to us within 7 days of purchase with the details on hello@careerninja.in",
  },
];

export const placementData = [
  {
    label: "Week 1",
    title: "Building the Ultimate Profile",
    subtitle: "CV + LinkedIn revamp to make your application stand out",
    video_link: "https://youtu.be/OKVe7qahDoc",
    thumbnail:
      "https://img.learntube.ai/public-assets/Optimized_folder/premium/placementImages/week-1.jpg?updatedAt=1688366093369",
  },
  {
    label: "Week 2",
    title: "Creating Your Job Hunt Plan",
    subtitle: "Learn winning strategies that will get you shortlisted",
    video_link: "https://youtu.be/93Y-_Pzk7SM",
    thumbnail:
      "https://img.learntube.ai/public-assets/Optimized_folder/premium/placementImages/week-2.jpg?updatedAt=1688366094136",
  },
  {
    label: "Week 3",
    title: "Mastering The Elevator Pitch",
    subtitle: "Land multiple job interviews with the right skills & attitude",
    video_link: "https://youtu.be/Oa73QfUg9WI",
    thumbnail:
      "https://img.learntube.ai/public-assets/Optimized_folder/premium/placementImages/week-3.jpg?updatedAt=1688366094579",
  },
  {
    label: "Week 4",
    title: "Live Interview Training",
    subtitle: "Get hired with mock interviews & personalised feedback",
    video_link: "https://youtu.be/AKUVJT7UYl0",
    thumbnail:
      "https://img.learntube.ai/public-assets/Optimized_folder/premium/placementImages/week-4.jpg?updatedAt=1688366094496",
  },
];

export const placementSuccessStories = [
  {
    id: 1,
    name: "Shwetha S.",
    description: `After spending over two years in a role that didn’t excite me, I knew I needed a change, but with no tech background, the transition felt overwhelming. I applied to over 100 jobs and faced rejection after rejection, which was incredibly frustrating. That’s when I discovered LearnTube, and everything started to change.\n

What made the difference for me was the customized learning plan that was perfectly tailored to my needs. I gained hands-on experience through real-world projects that helped me build practical skills. The expert mentorship I received helped me navigate the challenges of being a fresher, and the polished resume I created showcased my new skills in a way that impressed recruiters. On top of that, the interview preparation boosted my confidence and gave me the tools to succeed.\n

Within just a month, I secured my dream role at Baker Hughes, with a 150% salary hike! It wasn’t easy, but I stayed committed, worked hard, and relentlessly upskilled. I’m truly grateful for the role LearnTube played in my journey.`,
    videoUrl: "https://youtu.be/0g9Ddz2ips8",
    from: "Customer Software Associate",
    to: "Data Engineer",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Shwetha%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(9).png?updatedAt=1706100044811",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Shwetha%20Company.png",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(2).png",
  },
  {
    id: 2,
    name: "Ankit S.",
    description: `After 5+ years in pharma R&D, I felt stuck. Everyone around me was in the same role for years, and I knew I needed a change. I spent 18 months trying to learn data on my own — YouTube, PDFs, tutorials. But I wasn’t making progress.\n

That’s when I joined LearnTube.\n

With a personalized learning path tailored to my background, I completed 4 real-world projects in just 30 days, including a healthcare ML model that showcased my expertise. The results were immediate. A recruiter from a top investment firm reached out. No tests, no endless interviews — just one conversation about my work, followed by a 35% salary hike.\n

LearnTube didn’t just teach me. They helped me build work that got me noticed. If you’re stuck, take the leap. The right support makes all the difference.
`,
    videoUrl: "https://youtube.com/shorts/OqqTNCIrKR0",
    from: "Computer Engineer",
    to: "Full Stack Developer",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Ankit%20Image.png",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Ankit%20Company.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205147.png?updatedAt=1706100149035",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(3).png",
  },
  {
    id: 3,
    name: "Selvam Pillai",
    description: `With over 8 years of experience, I realized that despite my practical background, I lacked a formal certification to stand out in the competitive job market. I discovered LearnTube by Career Ninja on Instagram and completed their “Recruitment” Certificate. The certification instantly boosted my credibility and opened up new opportunities.\n

After updating my LinkedIn and Naukri profiles with the certification, the response was overwhelming. I went from receiving 4-5 recruiter calls per week to 15-16, including from top MNCs like Intel, Solar Energy companies, and India’s First Insurance. It was clear that the certification made a significant impact on my job prospects.\n

LearnTube not only provided me with an industry-recognized certification but also offered structured learning and personalized support. Their guidance, along with help in crafting professional testimonials and branding, played a key role in enhancing my career.`,
    videoUrl: "https://www.youtube.com/shorts/API2-cAB9hc",
    from: "HR Executive",
    to: "Sr. Recruitment Consultant",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Selvam%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205148.png?updatedAt=1706100206471",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Selvam%20Company.png",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(4).png",
  },
  {
    id: 4,
    name: "Saitrik C",
    description: `I had the skills, a gold medal in MSc Cyber Security and 2.5 years of experience in vulnerability management. But despite all this, I felt like growth was out of reach, and I was stuck in my role.\n

That’s when I decided to enroll in LearnTube. I wanted to truly assess where I stood and see if I could level up my skills. The structured learning and certification program helped me sharpen my expertise and gain new insights that set me apart in my field.\n

I cracked the certification, and it didn’t take long for my manager to notice the difference. During my performance appraisal, he acknowledged the value I was now bringing to the team.\n

The result? A 75% salary hike, from ₹9L to ₹16L, and I didn’t even have to change jobs. It wasn’t about moving companies, it was about how my current company saw me in a completely new light.`,
    videoUrl: "https://www.youtube.com/shorts/aGfFzUIvAko",
    from: "Associate",
    to: "Consultant Vulnerability Researcher",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Saitrik%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205149.png?updatedAt=1706100257026",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Saitrik%20Company.png",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(5).png",
  },
  {
    id: 5,
    name: "Bhavmeet Kaur",
    description: `As a Senior Executive in Digital Marketing at Ablysoft, I recognized the need to elevate my skills for career advancement. Discovering LearnTube, a renowned learning platform, I focused on strengthening my SEO expertise to boost my prospects in placement interviews. LearnTube's video-based courses offered flexibility, allowing me to revise and enhance my knowledge at my convenience. The interactive learning approach made the process enjoyable.\n

Delving into LearnTube's SEO courses increased my confidence. Emphasizing practice and real-world applications, the platform enabled me to grasp concepts with clarity. Well-prepared, I faced interviews with confidence, securing a Management Trainee position at Reliance Retail. Joining on July 3, 2023, with a 24 LPA salary, this journey from Ablysoft to LearnTube and finally to Reliance Retail signifies growth, self-improvement, and determination. Grateful to LearnTube for the transformative learning experience that opened doors to this remarkable opportunity.`,
    videoUrl: "https://www.youtube.com/shorts/kf0sz6k4S3U",
    from: "Digital Marketing Executive",
    to: "Business Ops. Manager",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Bhavmeet%20image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205150.png?updatedAt=1706100314081",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Bhavmeet%20Company.png",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(7).png",
  },
  {
    id: 6,
    name: "Dr. Pritish",
    description: `During my final year of MBBS, I juggled various roles, including founding my startup, Fidorhealth, while holding prestigious positions like National IT Director at AMSA and Vice President at GAIM. To expand my digital reach and impact, I explored SEO and digital marketing, and that's when I found LearnTube. It offered free, high-quality content and valuable certificates, becoming my go-to platform.\n

 LearnTube's budget-friendly yet comprehensive content covered everything I needed to know, from digital marketing to mastering interview techniques. Despite facing personal challenges with cancer, I persevered and was honored by the Indian Book of Records. Thanks to LearnTube, I achieved financial success and now earn 10 LPA, realizing that continuous learning and staying updated are vital for sustained success.`,
    videoUrl: "https://youtu.be/KKpDsm0PPSc",
    from: "Student",
    to: "Co-Founder",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Pritish%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205151.png?updatedAt=1706100362879",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Pritish%20Company.png",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(8).png",
  },
  {
    id: 7,
    name: "Dasharath Shetty",
    description: `As an Oracle developer at TCS with 8 years of experience in the IT industry, my career was at a crossroads, and I longed for a change. That's when I stumbled upon LearnTube, a game-changing platform. I dug into Python through LearnTube's comprehensive courses, mastering it from the basics to advanced concepts. The structured approach and practical examples fueled my learning journey.\n

Coding slowly became my second nature, and I felt more confident than ever before. With my newfound knowledge, I landed a job with a lucrative salary of 15 LPA, thanks to LearnTube. Now, I'm reentering the IT industry with updated skills and expertise, all thanks to LearnTube's guidance and practical knowledge.
`,
    videoUrl: "https://youtube.com/shorts/Fkk68_W4b90",
    from: "Salesforce Analyst",
    to: "Sr. Product Analyst",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Dasharath%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205152.png?updatedAt=1706100433715",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Dashrath%20Company.png",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(9).png",
  },
  {
    id: 9,
    name: "Papia Chakraborty",
    description: `In June 2022, I embarked on my entrepreneurial journey, founding CUREASURE, an Assam-based startup, armed with 7 years of digital marketing experience and Photoshop proficiency. As the sole person handling everything, I knew continuous growth was vital.\n

Discovering LearnTube was a revelation - it aligned perfectly with my goals of managing the startup while upgrading my skills. Their practical courses empowered me to build my website, resulting in a 60% increase in traffic retention.\n

With each earned certificate, my online presence soared - followers increased by 80 per month, and impressions reached over 200. Today, my startup flourishes, generating a monthly income of 5,000 to 10,000 rupees,proving that investing in knowledge and upskilling is the true path to success.`,
    videoUrl: "https://youtu.be/IO8RJWDgvio",
    from: "Sr. Executive Assistant",
    to: "Operations Manager",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Papia%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205153.png?updatedAt=1706100491936",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Papia%20Company.png",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(10).png",
  },
  {
    id: 10,
    name: "Dinesh Gupta",
    description: `From facing financial hardships to becoming a self-made professional, my journey has been nothing short of inspiring. With a generous scholarship from Make a Difference (MAD), I pursued my college education. I switched to a BSc in Computer Science due to unaffordable engineering college fees.\n

In 2022, I stumbled upon LearnTube, which offered free education and job prospects. I seized the opportunity and focused on learning ML, C++, and advanced programming through webinars and resume-building sessions. Despite setbacks, I secured shortlisted opportunities from renowned companies like Goldman Sachs, Paypal, Mirae Asset Capital, Kalyan Jewellers, and Omniversity.\n

Eventually, I joined Mirae Asset Capital as a software developer in the capital market division. Earning 4.5 lakhs per annum with a 50,000 rupee bonus, I continue learning from LearnTube, preparing for my future. I've learned that challenges don't dictate our paths. With determination, education, and the willingness to learn, we can turn dreams into reality.
`,
    videoUrl: "https://youtu.be/owPU14dLvqs",
    from: "Developer",
    to: "Software Developer",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Dinesh%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205154.png?updatedAt=1706100529885",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Dinesh%20Company.png",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(1).png",
  },

  {
    id: 11,
    name: "Meenakshi J.",
    description: `Juggling life as a mom, wife, and professional, I always dreamed of building a meaningful career in IT. But balancing responsibilities, facing rejections, and dealing with self-doubt wasn’t easy.\n

That’s when I found LearnTube. With their support, I sharpened my skills, revamped my CV, and built the confidence to aim higher. In just 27 days, I achieved my goal as a Data Scientist with a 30% salary hike!`,
    videoUrl: "https://youtube.com/shorts/XzNJV9qZXa0",
    from: "Associate",
    to: "Data Scientist",
    thumbNail:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Meenakshi%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(9).png?updatedAt=1706100044811",
    companyLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Meenakshi%20Company.png",
    companyModalLogo:
      "https://storage.googleapis.com/learntube-web-assets/files/Academy%20bundle/Modal%20icon%20(6).png",
  },
];

export const recognitionSection = [
  {
    name: "Sainath Bavandlapally",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1744035431494%20(1).jpg?updatedAt=1745653213999",
    previousOrg: "",
    previousRole: "",
    city: "Hyderabad",
    finalOrg: "Amazon",
    finalOrgTitle: "Amazon",
    showAnimation: false,
    showText: true,
    finalRole: "ML Data Associate - II",
    statements: [
      "Completed Business Analyst Certificate",
      "Shared Certificate to Linkedin",
      "Growing his career at Amazon",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_amazon_com-symbol-dark_white.png?updatedAt=1746265349125",
  },
  {
    name: "Nikhil Singh",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1642956606077.jpg?updatedAt=1745654560176",
    previousOrg: "",
    previousRole: "",
    city: "Hyderabad",
    finalOrg: "Google",
    finalOrgTitle: "Google",
    showAnimation: false,
    showText: true,
    finalRole: "Quality Assurance Senior Associate",
    statements: [
      "Completed Scrum Master Certificate",
      "Li Recognition from pros at Uber, Google",
      "Growing his career at Google",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_google_com-symbol-dark_white.png?updatedAt=1746265427244",
  },
  {
    name: "Ankit Dubey",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1728052184938.jpg?updatedAt=1745655258806",
    previousOrg: "",
    previousRole: "",
    city: "Delhi",
    finalOrg: "Adobe",
    finalOrgTitle: "Adobe",
    showAnimation: false,
    showText: true,
    finalRole: "Business Analyst- Global Partner strategy and Sales Operations",
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from pros at EY, Flipkart",
      "Growing his career at Adobe",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_adobe_com-symbol-dark_white.png?updatedAt=1746265487663",
  },
  {
    name: "Anirudh Saravanan",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1735201462837.jpg?updatedAt=1745655355305",
    previousOrg: "",
    previousRole: "",
    city: "Chennai",
    finalOrg: "Mercedes-Benz India",
    finalOrgTitle: "Mercedes-Benz India",
    finalRole: "Senior Engineer",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from Sr. VP at Mercedes",
      "Growing his career at Mercedes",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/mercedes_benz_com-logo-light_white.png?updatedAt=1746265542811",
  },
  {
    name: "Aditya Bagdare",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1735931454957.jpg?updatedAt=1745655545521",
    previousOrg: "ICICI Prudential Life Insurance Company Limited",
    previousRole:
      "Data Visualisation: Empowering Business with Effective Insights",
    city: "Mumbai",
    finalOrg: "FedEx",
    finalOrgTitle: "FedEx",
    showAnimation: true,
    showText: false,
    finalRole: "Data Visualisation Specialist",
    statements: [
      "Completed Advance Excel Certificate",
      "Added Certificate to his resume",
      "Landed a job at FedEx US",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_fedex_com-logo-light_white%20(2).png?updatedAt=1746265608976",
  },
  {
    name: "Kumar Saurav",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1739813957095.jpg?updatedAt=1745655870110",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "EY",
    finalOrgTitle: "EY",
    showAnimation: false,
    showText: false,
    finalRole: "Senior Project Consultant",
    statements: [
      "Completed Scrum Master Certificate",
      "Li Recognition from Manager at HSBC",
      "Growing his career at Ernst & Young",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_ey_com-logo-dark_white.png?updatedAt=1746265670995",
  },
  {
    name: "Shweta Singh",
    profileImage:
      "https://img.learntube.ai/public-assets/New%20Landing%20Page/image.png?updatedAt=1744024275926",
    previousOrg: "Accenture",
    previousRole: "Data Analyst",
    city: "Mumbai",
    finalOrg: "Baker Hughes",
    finalOrgTitle: "Baker Hughes",
    finalRole: "Data Analyst",
    showAnimation: true,
    showText: true,
    statements: [
      "Completed Data Science Certificate",
      "20+ interviews unlocked with Certification",
      "Got 150% salary hike at Baker Hughes US",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_bakerhughes_com-symbol-dark_white%20(1).png?updatedAt=1746265717718",
  },
  {
    name: "Karthik V",
    profileImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/1605015867066.jpg?updatedAt=1746273338826",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "Samsung R&D Institute India",
    finalOrgTitle: "Samsung R&D Institute India",
    finalRole: "Sr.Chief Engineer",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Python Certificate",
      "Li Recognition from 15+ colleagues",
      "Growing career at Samsung",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/samsung_com-logo-dark_white.png?updatedAt=1746273456378",
  },
  {
    name: "Kumar Vaibhav",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1740119553553.jpg?updatedAt=1746154650158",
    previousOrg: "",
    previousRole: "",
    city: "Hyderabad",
    finalOrg: "Safe Security, ex-Uber",
    finalOrgTitle: "Uber",
    showAnimation: false,
    showText: false,
    finalRole: "Product Experience Manager",
    statements: [
      "Completed Product Management Certificate",
      "Li Recognition from CPO at Camunda US",
      "Growing his PM career at Safe Security",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/uber_com-logo-dark_white.png?updatedAt=1746273098349",
  },
  {
    name: "Rohan Dive",
    profileImage:
      "https://img.learntube.ai/public-assets/academy%20placement/Frame%20427322392.png",
    previousOrg: "",
    previousRole: "",
    city: "Japan",
    finalOrg: "Walmart",
    finalOrgTitle: "Walmart",
    finalRole: "Business Analyst",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Introduction to Python Certificate",
      "Shared Certificate to Linkedin",
      "Growing career at Walmart",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/Walmart.png?updatedAt=1746427878057",
  },
  {
    name: "Mallakunta Tharun Kumar",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1741745368780.jpg?updatedAt=1746154850842",
    previousOrg: "eBlackbucks Group🦌",
    previousRole: "Intern",
    city: "Bengaluru",
    finalOrg: "Dell Technologies",
    finalOrgTitle: "Dell Technologies",
    finalRole: "Software Engineer",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed HTML Certificate",
      "Added Certificate to Resume",
      "Landed first job at Dell",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_dell_com-other-light_white%20(1).png?updatedAt=1746265830189",
  },
  {
    name: "Abhishek Pratap Singh",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1743448722424.jpg?updatedAt=1746155403401",
    previousOrg: "",
    previousRole: "",
    city: "Noida",
    finalOrg: "HCLTech",
    finalOrgTitle: "HCLTech",
    finalRole: "Lead Analyst",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Project Management Certificate",
      "Shared Certificate to Linkedin",
      "Growing career at HCLTech",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_hcltech_com-logo-dark_white.png?updatedAt=1746265909135",
  },
  {
    name: "Antra Soni",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1710413707682.jpg?updatedAt=1746155577860",
    previousOrg: "Adani Airport Holdings Ltd · Internship",
    previousRole: "Summer Intern",
    city: "Ghaziabad",
    finalOrg: "KPMG India",
    finalOrgTitle: "KPMG India",
    finalRole: "Analyst",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Azure Cloud Certificate",
      "Added Certificate to Resume",
      "Landed first job at KPMG",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_kpmg_com-logo-dark_white.png?updatedAt=1746265970747",
  },
  {
    name: "Akash Goswami",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1740207031737.jpg?updatedAt=1746155755497",
    previousOrg: "Capgemini",
    previousRole: "Manager",
    city: "Kolkata",
    finalOrg: "Deloitte",
    finalOrgTitle: "Deloitte",
    finalRole: "Senior Technology Specialist",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Scrum Master Certificate",
      "Li Recognition from Global Mngr. US +20",
      "Landed a job at Deloitte",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_deloitte_com-logo-dark_white.png?updatedAt=1746266153751",
  },
  {
    name: "Anusha Surathkal",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1710043325292.jpg?updatedAt=1746155916967",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "PwC",
    finalOrgTitle: "PwC",
    showText: false,
    finalRole: "Strategic Content & Operations Administrator",
    showAnimation: false,
    statements: [
      "Completed Project Management Certificate",
      "Li 👏 from Assc. Director, BioCentury US",
      "Growing career at PwC",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_pwc_com-logo-dark_white%20(1).png?updatedAt=1746266219557",
  },
  {
    name: "V. RaviKiran Bejjanki",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1724425944171.jpg?updatedAt=1746156089446",
    previousOrg: "Centre for Sight",
    previousRole: "Deputy Manager – Lead Management Team",
    city: "Delhi",
    finalOrg: "Forrester",
    finalOrgTitle: "Forrester",
    finalRole: "Manager, Customer Success Services (capitalisation)",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from pros at KPMG, Samsung",
      "Landed a job at Forrester",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_forrester_com-logo-dark_white%20(1).png?updatedAt=1746266274735",
  },
  {
    name: "Rahul Mathevan",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1611814163892.jpg?updatedAt=1746156266095",
    previousOrg: "",
    previousRole: "",
    city: "Chennai",
    finalOrg: "Moody's, ex-McKinsey",
    finalOrgTitle: "McKinsey",
    finalRole: "Senior Production Associate",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Product Management Certificate",
      "Li Recognition from pros at Barclay's +10",
      "Growing career at Moody's Investors Service",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/mckinsey_com-logo-light_white.png?updatedAt=1746426229880",
  },
  {
    name: "Aaksweta Ray",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1621020078379.jpg?updatedAt=1746156486146",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "Accenture, ex-Wipro",
    finalOrgTitle: "Wipro",
    finalRole: "Business Process Analyst",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Product Management Certificate",
      "Li Recognition from pros at Amazon",
      "Growing career at Accenture",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/wipro_com-logo-dark_white%20(1).png?updatedAt=1746425955870",
  },
  {
    name: "Rohan Kulkarni",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1647630418876.jpg?updatedAt=1746157895902",
    previousOrg: "Cognizant",
    previousRole: "Technical Lead",
    city: "Pune",
    finalOrg: "Accenture",
    finalOrgTitle: "Accenture",
    finalRole: "Service Manager",
    showAnimation: true,
    showText: true,
    statements: [
      "Completed Product Management Certificate",
      "Li Recognition from Crowstrike, Cognizant",
      "Landed a job at Accenture",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_accenture_com-symbol-dark_white%20(1).png?updatedAt=1746266410604",
  },
  {
    name: "Rishabh Singh",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1707274629746.jpg?updatedAt=1746157089980",
    previousOrg: "",
    previousRole: "",
    city: "Delhi",
    finalOrg: "Aon",
    finalOrgTitle: "Aon",
    finalRole: "IND Intern",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed SQL Certificate",
      "Li Recognition from peers at Visa, Amex",
      "Growing career at Aon",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_aon_com-logo-dark_white.png?updatedAt=1746266501341",
  },
  {
    name: "Venkatesh Kumar",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1718239804118.jpg?updatedAt=1746157284988",
    previousOrg: "",
    previousRole: "",
    city: "Chennai",
    finalOrg: "Citi",
    finalOrgTitle: "Citi",
    finalRole: "Assistant Vice President",
    showText: false,
    showAnimation: false,
    statements: [
      "Completed Six Sigma Certificate",
      "Li Recognition from VP @ Citi IE",
      "Growing career at Citi",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_citi_com-logo-dark_white.png?updatedAt=1746266551176",
  },
  {
    name: "Sai Badrish",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1537677823848.jpg?updatedAt=1746158062649",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "Standard Chartered Bank",
    finalOrgTitle: "Standard Chartered Bank",
    finalRole: "Technical Lead",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Tableau Certificate",
      "Li Recognition from Sr. Lead ML Engineer",
      "Growing career at Standard Chartered Bank",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_sc_com-symbol-dark_white.png?updatedAt=1746273031072",
  },
  {
    name: "Prayas Aute",
    profileImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/1616216183959.jpg?updatedAt=1746427990975",
    previousOrg: "",
    previousRole: "",
    city: "Pune",
    finalOrg: "Mastercard",
    finalOrgTitle: "Mastercard",
    finalRole: "Senior Project Manager",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Introduction to Python Certificate",
      "Shared Certificate to Linkedin",
      "Landed a job at Mastercard",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/Mastercard.png?updatedAt=1746429731530",
  },
  {
    name: "Chandan Jaiswal",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1685091144073.jpg?updatedAt=1746158686877",
    previousOrg: "",
    previousRole: "",
    city: "Delhi",
    finalOrg: "Barclays",
    finalOrgTitle: "Barclays",
    finalRole: "Deputy Manager",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from ThermoFisher 🇳🇱",
      "Growing career at Barclays",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_barclays_com-symbol-dark_white%20(1).png?updatedAt=1746266741491",
  },
  {
    name: "Milind Sonar",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1746028824711.jpg?updatedAt=1746158920275",
    previousOrg: "HDFC Bank",
    previousRole: "Trainee Credit Manager",
    city: "Pune",
    finalOrg: "HDFC Bank",
    finalOrgTitle: "HDFC Bank",
    finalRole: "Assistant Credit Manager",
    showAnimation: true,
    showText: true,
    statements: [
      "Completed Excel Data Analysis Certificate",
      "Shared Certificate to Linkedin",
      "Promoted to Assistant Credit Manager",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/HDFC.png?updatedAt=1746266815095",
  },
  {
    name: "Suraj Morgaonkar",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1718242674339.jpg?updatedAt=1746159229735",
    previousOrg: "Netwin Systems",
    previousRole: "Marketing Executive Head - Goa Region",
    city: "South Goa",
    finalOrg: "Axis Max Life Insurance",
    finalOrgTitle: "Axis Max Life Insurance",
    finalRole: "Agency Development Manager",
    showAnimation: true,
    showText: true,
    statements: [
      "Completed Scrum Master Certificate",
      "Li Recognition from Amazon, Boeing, Hilton",
      "Landed a job at Axis Max Life Insurance Limited",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_axisbank_com-symbol-dark_white.png?updatedAt=1746266867292",
  },
  {
    name: "Hariprasad R",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1678429481532.jpg?updatedAt=1746159830668",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "Wells Fargo",
    finalOrgTitle: "Wells Fargo",
    finalRole: "Sr. Assistant Vice President",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Data Analytics Certificate",
      "Shared Certificate to Linkedin",
      "Growing career at Wells Fargo",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_wellsfargo_com-logo-dark_white.png?updatedAt=1746266927717",
  },
  {
    name: "Abhinav Gupta",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1735831902106.jpg?updatedAt=1746159567277",
    previousOrg: "SAPRO",
    previousRole: "Operations Lead",
    city: "India",
    finalOrg: "HSBC",
    finalOrgTitle: "HSBC",
    finalRole: "AVP",
    showAnimation: true,
    showText: true,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from COO, CXO, Sapro US",
      "Landed a job at HSBC",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_hsbc_com-symbol-light_white%20(1).png?updatedAt=1746266984136",
  },
  {
    name: "Saptarshi Das",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1733074340143%20(1).jpg?updatedAt=1746160302153",
    previousOrg: "Sutherland",
    previousRole: "Lead IT Help Desk",
    city: "Bengaluru",
    finalOrg: "Infosys",
    finalOrgTitle: "Infosys",
    finalRole: "Team Leader",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Project Management Certificate",
      "Shared Certificate to Linkedin",
      "Landed a job at Infosys with a 42% Salary hike",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_infosys_com-logo-light_white%20(1).png?updatedAt=1746267038902",
  },
  {
    name: "Mohammed Haris",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1727640337534.jpg?updatedAt=1746160524054",
    previousOrg: "CRED",
    previousRole: "Associate",
    city: "Bengaluru",
    finalOrg: "CRED",
    finalOrgTitle: "CRED",
    finalRole: "Hierarchical Escalations",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Business Analyst Certificate",
      "Added Certificate to Resume",
      "Promoted to Hierarchical Escalations",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_cred_club-logo-light_white%20(1).png?updatedAt=1746267089691",
  },
  {
    name: "Shimsha  S M",
    profileImage:
      "https://img.learntube.ai/public-assets/linkedinpost/1729413209697.jpg?updatedAt=1745585175484",
    previousOrg: "Kuvempu Unversity",
    previousRole: "Masters",
    city: "Bengaluru",
    finalOrg: "Ola",
    finalOrgTitle: "Ola",
    finalRole: "Associate Engineer (Krutrim Maps)",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Oracle Cloud Infrastructure Certificate",
      "Added Certificate to Resume",
      "Landed a job at Ola",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/OLA.png?updatedAt=1746267140043",
  },
  {
    name: "Surajit Dan",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1699512511869.jpg?updatedAt=1746160969362",
    previousOrg: "Zomato",
    previousRole: "Fleet Operations Manager",
    city: "Kolkata",
    finalOrg: "Zomato",
    finalOrgTitle: "Zomato",
    finalRole: "Area Lead",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from PwC, Blinkit",
      "Promoted to Area Lead",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_zomato_com-logo-dark_white.png?updatedAt=1746267227819",
  },
  {
    name: "Suman Kumar Singh",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1738873583207.jpg?updatedAt=1746161449623",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "CARS24",
    finalOrgTitle: "CARS24",
    finalRole: "General Manager (Retail & Sales Head)",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from Harper-Collins",
      "Growing career at CARS24",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_cars24_com-logo-dark_white%20(1)%20(1).png?updatedAt=1746267298882",
  },
  {
    name: "Bhavya  Verma",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1742321576614.jpg?updatedAt=1746161733680",
    previousOrg: "PSIT COLLEGE OF ENGINEERING, KANPUR",
    previousRole: "BTech, CS AIML",
    city: "Bengaluru",
    finalOrg: "Flipkart",
    finalOrgTitle: "Flipkart",
    finalRole: "Application Engineer",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Machine Learning Core Essentials Certificate",
      "Li Recognition from Turing, Capgemini",
      "Landed a job at Flipkart",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/Flipkart.png?updatedAt=1746268316885",
  },
  {
    name: "Tarun Negi",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1707482947073.jpg?updatedAt=1746167091736",
    previousOrg: "",
    previousRole: "",
    city: "Noida",
    finalOrg: "Paytm",
    finalOrgTitle: "Paytm",
    finalRole: "Senior Associate",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from Leaders at Paytm",
      "Growing career at Paytm",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_paytm_com-logo-dark_white.png?updatedAt=1746268364141",
  },
  {
    name: "Anmol ‌‌‍Rane",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1735051622434.jpg?updatedAt=1746167657071",
    previousOrg: "StunHaul",
    previousRole: "HR Manager",
    city: "India",
    finalOrg: "Unacademy",
    finalOrgTitle: "Unacademy",
    finalRole: "Growth Specialist",
    showAnimation: true,
    showText: true,
    statements: [
      "Completed Introduction to Data Analytics Certificate",
      "Shared Certificate to Linkedin",
      "Landed a job at Unacademy",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/Unacademy.png?updatedAt=1746268418866",
  },
  {
    name: "Snehil Ashish",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1681793205736.jpg?updatedAt=1746168710927",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "upGrad",
    finalOrgTitle: "upGrad",
    finalRole: "Senior Operations Analyst",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from Program Manager, ISB",
      "Growing career at upGrad",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_upgrad_com-logo-dark_white.png?updatedAt=1746268468714",
  },
  {
    name: "Ishan Dev Shukl",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1742044922364.jpg?updatedAt=1746168881016",
    previousOrg: "",
    previousRole: "",
    city: "Gurgaon",
    finalOrg: "Nykaa",
    finalOrgTitle: "Nykaa",
    finalRole: "SDET Manager",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Scrum Master Basic Certificate",
      "Li Recognition from DE Shaw, Postman",
      "Growing career at Nykaa",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_nykaa_com-logo-dark_white%20(1).png?updatedAt=1746268520813",
  },
  {
    name: "Shounak Singh",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1697824186285.jpg?updatedAt=1746169123698",
    previousOrg: "",
    previousRole: "",
    city: "Gurgaon",
    finalOrg: "ixigo",
    finalOrgTitle: "ixigo",
    finalRole: "Senior Manager - Partnerships",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from Paytm, MakeMyTrip",
      "Growing career at ixigo",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_ixigo_com-logo-dark_white%20(2).png?updatedAt=1746268574984",
  },
  {
    name: "Sachin Kumar Mahto",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1547213326368.jpg?updatedAt=1746169273128",
    previousOrg: "",
    previousRole: "",
    city: "Jamshedpur",
    finalOrg: "Swiggy",
    finalOrgTitle: "Swiggy",
    finalRole: "Chat support executive",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Microinteractions Certificate",
      "Li Recognition from Founder, FourDots",
      "Growing career at Swiggy",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_swiggy_com-symbol-dark_white%20(1).png?updatedAt=1746268622453",
  },
  {
    name: "Rinku Majumdar",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1725012091229.jpg?updatedAt=1746169502393",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "Samaaro, ex-Jupiter",
    finalOrgTitle: "Jupiter",
    finalRole: "Customer Success Manager",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Introduction to Project Management Certificate",
      "Shared Certificate to Linkedin",
      "Growing career at Samaaro",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_jupiter_com-logo-light_white.png?updatedAt=1746273226370",
  },
  {
    name: "Vishnu Sathikumar",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1739848066260.jpg?updatedAt=1746169734023",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "udaan.com",
    finalOrgTitle: "udaan.com",
    finalRole: "Associate Manager",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from Assoc. Director, Udaan",
      "Growing career at udaan.com",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/Udaan.png?updatedAt=1746268718462",
  },
  {
    name: "Piyush Singh",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1737906681773.jpg?updatedAt=1746169952925",
    previousOrg: "Flipkart",
    previousRole: "Operation Executive",
    city: "Jaipur",
    finalOrg: "Meesho",
    finalOrgTitle: "Meesho",
    finalRole: "Area Operation Manager",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Search Engine Marketing Basics Certificate",
      "Li Recognition from pros at Amazon, Myntra",
      "Landed a job at Meesho",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_meesho_com-logo-dark_white%20(1).png?updatedAt=1746268774146",
  },
  {
    name: "Sourav Sharma",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1718284268971.jpg?updatedAt=1746170205404",
    previousOrg: "WiseX",
    previousRole: "Product Manager",
    city: "Faridabad",
    finalOrg: "Freecharge",
    finalOrgTitle: "Freecharge",
    finalRole: "Lead Business Analyst",
    showAnimation: true,
    showText: false,
    statements: [
      "Completed Scrum Master Basic Certificate",
      "Li Recognition from AVP @ MapMyIndia",
      "Landed a job at Freecharge",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_freecharge_com-logo-dark_white.png?updatedAt=1746268829685",
  },
  {
    name: "Himanshu Sinha",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1716132382198.jpg?updatedAt=1746170425591",
    previousOrg: "",
    previousRole: "",
    city: "Dubai",
    finalOrg: "noon, ex-Shadowfax",
    finalOrgTitle: "Shadowfax",
    finalRole: "Cluster Manager - Logistics",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from Amazon, Flipkart",
      "Landed a job at noon",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/Shadowfax.png?updatedAt=1746272980237",
  },
  {
    name: "Kamal Singh",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1677751685877.jpg?updatedAt=1746170684043",
    previousOrg: "",
    previousRole: "",
    city: "New Delhi",
    finalOrg: "Rastey, ex-Treebo Hotels",
    finalOrgTitle: "Treebo Hotels",
    finalRole: "Hotel Operations Manager",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Project Management Certificate",
      "Added Certificate to Resume",
      "Landed a job at Rastey Commuting Services (P)Limited",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/Treebo.png?updatedAt=1746272899498",
  },
  {
    name: "Arun Muthukrishnan",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1517420457144.jpg?updatedAt=1746171226719",
    previousOrg: "",
    previousRole: "",
    city: "Chennai",
    finalOrg: "NoBroker.com",
    finalOrgTitle: "NoBroker.com",
    finalRole: "Senior Business Performance Consultant",
    showAnimation: false,
    showText: true,
    statements: [
      "Completed Scrum Master Basics Certificate",
      "Li Recognition from Amazon, Zoho, Ford",
      "Growing career at NoBroker.com",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/NoBroker.png?updatedAt=1746268955925",
  },
  {
    name: "Abdurrahman Shaik",
    profileImage:
      "https://img.learntube.ai/public-assets/recognised_section/1744921943408.jpg?updatedAt=1746171515971",
    previousOrg: "",
    previousRole: "",
    city: "Bengaluru",
    finalOrg: "MyGate",
    finalOrgTitle: "MyGate",
    finalRole: "Senior Manager",
    showAnimation: false,
    showText: false,
    statements: [
      "Completed Project Management Certificate",
      "Li Recognition from Manager, PhonePe",
      "Growing career at MyGate",
    ],
    companyImage:
      "https://img.learntube.ai/public-assets/New%20Recognised%20Section/www_mygate_com-logo-light_white%20(1).png?updatedAt=1746269017358",
  },
];

export const userActivity = {
  QUIZ_COMPLETION: { type: "quiz_completion", cost: 0 },
  ASK_DOUBT_NORMAL: { type: "ask_doubt_normal", cost: 10 },
  ASK_DOUBT_EXPERT: { type: "ask_doubt_expert", cost: 70 },
  ASK_TASK_REVIEW: { type: "ask_task_review", cost: 200 },
  UNLOCK_FAQ_SECTION: { type: "unlock_faq_section", cost: 10 },
  SYNC_GOOGLE_CONTACTS: { type: "sync_google_contacts", cost: 0 },
  NEW_USER_REFERRAL: { type: "new_user_referral", cost: 0 },
  CERTIFICATE_DOWNLOAD_CLICK: {
    type: "certificate_download_button_clicked",
    cost: 0,
  },
  DOWNLOAD_PAID_CERTIFICATE: { type: "download_paid_certificate", cost: 100 },
  DOWNLOAD_FREE_CERTIFICATE: { type: "download_free_certificate", cost: 0 },
  LESSON_WATCHED: { type: "lesson_watched", cost: 0 },
  LESSON_COMPLETED: { type: "lesson_completed", cost: 0 },
  NEW_SEARCH: { type: "new_search", cost: 0 },
  COURSE_ENROLLED: { type: "course_enrolled", cost: 0 },
  ADDED_NOTE: { type: "added_note", cost: 0 },
  WRONG_ANSWER_PENALTY: { type: "wrong_answer_penalty", cost: 20 },
  SHARE_WHATSAPP: { type: "share_whatsapp", cost: 0 },
  SHARE_FACEBOOK: { type: "share_facebook", cost: 0 },
  SHARE_LINKEDIN: { type: "share_linkedin", cost: 0 },
  SHARE_TWITTER: { type: "share_twitter", cost: 0 },
  SHARE_MESSENGER: { type: "share_messenger", cost: 0 },
  ANSWER_DOUBT: { type: "answer_doubt", cost: 0 },
  MSKILL_COMPLETED: { type: "mskill_completed", cost: 0 },
  UNSUBSCRIBED: { type: "unsubscribed", cost: 0 },
  SUBSCRIBED: { type: "subscribed", cost: 0 },
  LESSON_STARTED: { type: "lesson_started", cost: 0 },
  CHALLENGE_ACCEPTED: { type: "challenge_accepted", cost: 0 },
  CHALLENGE_COMPLETED: { type: "challenge_completed", cost: 0 },
  CONTACT_SUPPORT: { type: "contact_support", cost: 0 },
  SIGNIN: { type: "signin", cost: 0 },
  SIGNUP: { type: "signup", cost: 0 },
  DOWNLOAD_PAID_CERTIFICATE_SKILL: {
    type: "download_paid_certificate_skill",
    cost: 500,
  },
  DOWNLOAD_FREE_CERTIFICATE_SKILL: {
    type: "download_free_certificate_skill",
    cost: 0,
  },
  WEBINAR_REGISTRATION_PAID: { type: "webinar_registration", cost: 200 },
  WEBINAR_REGISTRATION_FREE: { type: "webinar_registration_free", cost: 0 },
  JOB_APPLICATION_SUCCESS: { type: "job_application_success", cost: 0 },
  JOB_APPLICATION_ATTEMPT: { type: "job_application_attempt", cost: 0 },
  PAYMENT_ATTEMPT: { type: "payment_attempt", cost: 0 },
};

export const discountActivity = {
  ASK_DOUBT: {
    type: "ask_doubt",
    message: "Asking your First Doubt on Platform",
  },
  MSKILL_COMPLETED: {
    type: "mskill_completed",
    message: "Completing your First Micro-skill",
  },
  MSKILL_ENROLLED: {
    type: "mskill_enrolled",
    message: "Enrolling Into your First Micro-skill",
  },
  COMPLETED_TWO_LESSONS_IN_SKILL: {
    type: "completed_two_lessons_in_skill",
    message: "Completing two lessons",
  },
  COMPLETED_TWO_MSKILL: {
    type: "two_mskill_completed",
    message: "Completing two mskills",
  },
  COMPLETED_THREE_MSKILL: {
    type: "three_mskill_completed",
    message: "Completing three mskills",
  },
  TRIAL_ENDED: {
    type: "trial_ended",
    message: "Completing LT-Max Trial Period",
  },
};

export const leadScoringActivity = {
  PURCHASED_COINS: { type: "purchased_coins" },
  PURCHASED_SUBSCRIPTION: { type: "purchased_subscription" },

  VISITED_PRICING_PAGE: { type: "visited_pricing_page" },
  CLICKED_LTPRO: { type: "clicked_LTPRO" }, //clicked on button
  CLICKED_LTPROPLUS: { type: "clicked_LTPROPLUS" },
  CLICKED_LTX: { type: "clicked_LTX" },
  CLICKED_LTMAX: { type: "clicked_LTMAX" },

  CLICKED_LTPRO_CARD: { type: "clicked_LTPRO_card" }, //clicked on card
  CLICKED_LTPROPLUS_CARD: { type: "clicked_LTPROPLUS_card" },
  CLICKED_LTX_CARD: { type: "clicked_LTX_card" },
  CLICKED_LTMAX_CARD: { type: "clicked_LTMAX_card" },

  REQUESTED_HELP: { type: "requested_help" }, //kholne pe hai
  CHECKED_ELIGIBILITY: { type: "checked_eligibility" },

  CLICKED_GENERAL: { type: "clicked_general" }, //pricing page's general buttons such as faqs etc

  COMPLETED_MSKILL: { type: "completed_mskill" },
  COMPLETED_SKILL: { type: "completed_skill" },

  COMPLETED_CHALLENGE: { type: "completed_challenge" },
  ACCEPTED_CHALLENGE: { type: "accepted_challenge" },

  REGISTERED_WEBINAR: { type: "registered_webinar" },

  APPLIED_JOB: { type: "applied_job" }, //job
};

export const redirectUrls = [
  "referralsignup",
  "webapp2-collegereferral",
  "webapp-collegereferral",
  "collegereferral",
  "early-access-3-webapp",
  "early-access-webapp",
  "early-access",
];

export const checklistActivities = [
  {
    type: "quiz_completion",
    checklistLabel: "Complete a Quiz",
    image: CompleteMskill,
  },
  {
    type: "signup",
    checklistLabel: "Sign Up",
    image: Signup,
  },
  {
    type: "signin",
    checklistLabel: "Sign Up",
    image: Signup,
  },
  {
    type: "lesson_started",
    checklistLabel: "Start A Course",
    image: CourseUnlocked,
  },
  // {
  //     type: "milestone",
  //     checklistLabel: "Course Unlocked for Free",
  //     image: CourseUnlocked,
  // },
  {
    type: "challenge_accepted",
    checklistLabel: "Start One Day Challenge",
    image: QuizComplete,
  },
  {
    type: "challenge_completed",
    checklistLabel: "Complete Micro Skill in One Day",
    image: completemskil1day,
  },
  // {
  //     type: "download_paid_certificate",
  //     checklistLabel: "Unlock Free Certificate",
  //     image: Certificate
  // },
  // {
  //     type: "download_free_certificate",
  //     checklistLabel: "Unlock Free Certificate",
  //     image: Certificate
  // },
];
export const DOMAIN_DEFAULT = [
  "Data Structure and Algorithm",
  "Digital Marketing Fundamentals",
  "Python Basic (English)",
  "Photoshop Basic",
  "Forex",
  "UI/UX Fundamentals for Beginners",
  "Business Intelligence",
  "Amazon Web Services Analytics",
  "MySQL",
  "Theory and Practical Cinematography",
];

export const DOMAIN_PROGRAMMING = [
  "Data Structure and Algorithm",
  "Java Basic",
  "React JS",
  "Android App Development",
  "PostgreSQL",
  "HTML",
  "JavaScript Basic",
  "C Programming",
  "Django Basics",
  "PHP",
];

export const DOMAIN_DIGITAL_MARKETING = [
  "Digital Marketing Fundamentals",
  "Social Media Marketing",
  "Search Engine Marketing",
  "Email Marketing",
  "Branding & Design Essentials",
  "CRM & Community Building",
  "Paid Ads and Paid Media",
  "Google Analytics",
  "Display Advertisements",
  "Remarketing & Growth Hacking",
];

export const DOMAIN_DATA_SCIENCE_AND_ANALYTICS = [
  "Python Basic (English)",
  "Python Advanced (English)",
  "Machine Learning",
  "Deep Learning",
  "Tableau Basic",
  "Tableau Advanced",
  "Python Basic (Hindi)",
  "Python Advanced (Hindi)",
  "Power BI Basic",
  "Power BI Advanced",
];

export const DOMAIN_DESIGN_ART_AND_TOOLS = [
  "Photoshop Basic",
  "Blender Advanced",
  "After Effects",
  "Illustrator",
  "AutoCAD",
  "GIMP",
  "Premier Pro",
  "Lightroom",
  "Motion Graphics Basic",
  "Graphic Designing - Concepts",
];

export const DOMAIN_FINANCE_AND_INVESTMENTS = [
  "Forex",
  "Stock Market Advanced",
  "Tally Hindi",
  "Fundamentals of SAP",
  "Financial Accounting",
  "Accounting Documents",
  "Bank Controlling",
];

export const DOMAIN_UI_UX = [
  "Figma",
  "UI/UX Fundamentals for Beginners",
  "Careers in UX Design",
  "Foundations of Design and Design Thinking Application",
  "Product/ UX Strategy",
  "Information Architecture",
  "Surveying Data through Card Sorting & Site Maps",
  "Task Flow & User Flow",
  "Wireframing, Prototyping, & Laws for UX",
  "Elements of UI Design",
  "Designer Developer Handoff",
];

export const DOMAIN_LANGUAGES = [
  "Data Structure and Algorithm",
  "Digital Marketing Fundamentals",
  "Python Basic (English)",
  "Photoshop Basic",
  "Forex",
  "UI/UX Fundamentals for Beginners",
  "Business Intelligence",
  "Amazon Web Services Analytics",
  "MySQL",
  "Theory and Practical Cinematography",
];

export const DOMAIN_BUSINESS_AND_MANAGEMENT = [
  "How To Freelance?",
  "Microsoft Word Basic",
  "Product Management",
  "Business Intelligence",
  "Microsoft Powerpoint Basic",
  "Microsoft Powerpoint Advanced",
  "Google Docs",
  "Microsoft Excel Basic",
  "Microsoft Excel Advanced",
  "Google Sheets",
];

export const DOMAIN_CLOUD_COMPUTING = [
  "Oracle Cloud Core Infrastructure Basic Foundations",
  "Oracle Cloud Core Infrastructure Advanced Foundations",
  "Amazon Web Services Analytics",
  "Amazon Web Services Database",
  "Azure",
  "Docker Basic",
  "Docker Advanced",
  "Linux for DevOps Engineers in Hindi by TrainWithShubham",
  "Kubernetes",
];

export const DOMAIN_OS_AND_DB = [
  "SQL Basic",
  "SQL Advanced",
  "MySQL",
  "Linux Basic",
  "Linux Advanced",
  "Shell Scripting",
  "Mongo DB",
  "Redis",
];

export const DOMAIN_HARDWARE_AND_SECURITY = [
  "Arduino",
  "Hacking",
  "Cyber Security",
  "Data Structure and Algorithm",
  "Digital Marketing Fundamentals",
  "Python Basic (English)",
  "Photoshop Basic",
  "Forex",
  "UI/UX Fundamentals for Beginners",
  "Business Intelligence",
];

export const DOMAIN_FILM_MAKING = [
  "Theory and Practical Cinematography",
  "Sparkling Art of Film Direction",
  "Film Financing and Distribution",
  "Film Advertising and Public Relations",
  "Film Production Design",
  "Film Theories and its Societal Impact",
  "Sound Production and Design",
  "Sound Designing on Set",
  "Film Editing",
  "Story, Scripting and Story Boarding",
];

export const DOMAIN_DEVELOPMENT_TOOLS_NO_CODE = [
  "Git",
  "Salesforce App Builder and Administrator",
  "WordPress",
  "Jenkins",
  "Android Studio",
  "WIX",
  "Unreal Engine",
  "Joomla",
  "Jira",
  "Software Testing",
];

export const DOMAIN_WEB_3 = [
  "Blockchain",
  "Digital Marketing Fundamentals",
  "Python Basic (English)",
  "Photoshop Basic",
  "Forex",
  "UI/UX Fundamentals for Beginners",
  "Business Intelligence",
  "Amazon Web Services Analytics",
  "MySQL",
  "Theory and Practical Cinematography",
];

export const DOMAIN_MUSIC = [
  "Piano",
  "Guitar Basic",
  "Guitar Advanced",
  "Piano Crash Course",
  "Violin",
  "FL Studio Begginer Music Production",
  "FL Studio 20 - Music Production In FL Studio for Mac & PC",
  "FL Studio 12",
  "FL Studio 12 Music Making",
  "FL Studio Hardstyle Production Hard Dance Music Production",
];

export const OUR_LEARNERS_SECTION = [
  {
    studentName: "Yashika Zutshi",
    studentImage:
      "https://img.learntube.ai/public-assets/Optimized_What_learners_about_us/yashika_zutshi.webp?updatedAt=1690005372905",
    companyLogo: DuTimes,
    bgColor: "#74d3c3",
    label: "Interning at",
    desc: `After the course, I was able to get 2 Digital Marketing internships, one at DU Times and another at ManKiBaat. I not only got a stipend hike but also an opportunity to apply my newly gained knowledge practically and create content strategies! The course truly delivers perfect modules required to understand digital marketing!

Got 2 Internships, one at DU Times and another one at MaanKiBaat`,
  },
  {
    studentName: "Vinuthan Raj ",
    studentImage:
      "https://img.learntube.ai/public-assets/Optimized_What_learners_about_us/vinuthan_raj.webp?updatedAt=1690005371810",
    companyLogo: Company5,
    bgColor: "#FFC200",
    label: "Course Review",
    desc: `My experience with career ninja has been great. Learning from the experts is really insightful and the practical approach has helped me understand things in depth. I would totally recommend this to people who are willing to learn Digital Marketing

Practical Approach to Learning Appreciated!`,
  },
  {
    studentName: "Madhuri Dattagupta",
    studentImage:
      "https://img.learntube.ai/public-assets/Optimized_What_learners_about_us/madhuri.webp?updatedAt=1690005367852",
    companyLogo: Company6,
    bgColor: "#92F32F",
    label: "Interning at",
    desc: `If you are looking for a good digital marketing course, you need to check out Career Ninja! I came across CareerNinja on Instagram and immediately registered. They helped me find the perfect syllabus according to my requirements. I received 1:1 online mentorship sessions with industry experts and a live industry project. They also helped me polish my CV to apply for jobs.

Wholesome, Practical, Personalised Course!`,
  },
  {
    studentName: "Apeksha Jain",
    studentImage:
      "https://img.learntube.ai/public-assets/Optimized_What_learners_about_us/apeksha_jain.webp?updatedAt=1690005367954",
    companyLogo: Company7,
    bgColor: "#74d3c3",
    label: "Personal Achievement",
    desc: `I was able to start my own Instagram page and website and was able to increase page engagement. It has given me understanding of concepts, such as SEO, Google Analytics, SEO tools, SSM all of which have helped my growth. The course is very detailed and easy to understand, with videos as well as articles!! Highly recommend 

Started her own Instagram page and Website`,
  },
  {
    studentName: "Durbha Sri Hari",
    studentImage:
      "https://img.learntube.ai/public-assets/Optimized_What_learners_about_us/durbha.webp?updatedAt=1690005367972",
    companyLogo: Company1,
    bgColor: "#FFC200",
    label: "Working At",
    desc: `I was Unsure About Where to Start.The Mentors at CareerNinja Helped Me To Get My Confidence Back and Because of This I Happened To Clear The Interview of One of The Biggest Digital Marketing Agencies in The World, GroupM.`,
  },
  {
    studentName: "Priya Jagwani",
    studentImage:
      "https://img.learntube.ai/public-assets/Optimized_What_learners_about_us/1589788142105.webp?updatedAt=1690005367987",
    companyLogo: Company2,
    bgColor: "#92F32F",
    label: "Placed At",
    desc: `I had to crack an interview before even starting my sessions, the team helped me through that and I got my job! The unique customisation, 1:1 mentorship and the fees are a very attractive combination! Placed at BillEasy, a consumer tech company`,
  },
  {
    studentName: "Silviya Jasmin Golmes",
    studentImage:
      "https://img.learntube.ai/public-assets/Optimized_What_learners_about_us/file.webp?updatedAt=1690005368089",
    companyLogo: Company3,
    bgColor: "#74d3c3",
    label: "Personal Achievement",
    desc: `My goal towards Digital Marketing was building personal brand. With the Help Of CareerNinja’s Course, I Was not only Able To Increase Engagement On My Instagram but also Sell My Artwork By Applying Social Media Strategies. It is one of the best courses I came across!

70% Increase In Engagment on Personal Instagram`,
  },
  {
    studentName: "Aditya Taneja",
    studentImage:
      "https://img.learntube.ai/public-assets/Optimized_What_learners_about_us/aditya_taneja.webp?updatedAt=1690005367849",
    companyLogo: Company8,
    bgColor: "#FFC200",
    label: "Personal Achievement",
    desc: `With the CareerNinja course, at first, I cleared my Digital Marketing basics. The follow up mentorship sessions were very helpful to learn the practical applications of it! CareerNinja also gives an option of 1:1 soft-skills coaching which not only taught me networking and effective leadership but I also got exposed to key things like time-management. I am passionate about helping Startups build and scale their Online Presence and CareerNinja directly and positively impacted my career!

Direct, Postive Impact on Freelance Career`,
  },
  {
    studentName: "Sarosh Aadil",
    studentImage:
      "https://img.learntube.ai/public-assets/Optimized_What_learners_about_us/sarosh_aadil.webp?updatedAt=1690005367996",
    companyLogo: Company10,
    bgColor: "#74d3c3",
    label: "Internship At",
    desc: `I opted for CareerNinja’s Premium Plan and trust me it's totally worth the money. My mentor, with his brilliant skills and knowledge, not only helped me develop my Digital Marketing skills but also build my CV. I cracked a Social Media Marketing Internship at Capsley, a Bangalore-based startup, right after completing the program. This course helped me to lay the strong foundation before I can start my career!

Cracked an Internship at Capsley, a Bangalore based agency`,
  },
];

export const validPaths = [
  "/onboarding/questions/1",
  "/onboarding/questions/2",
  "/onboarding/questions/3",
  "/onboarding/questions/4",
  "/onboarding/questions/5",
  "/onboarding/questions/6",
  "/onboarding/questions/7",
];

export const successStories = [
  {
    id: 1,
    name: "Kishore V",
    description:
      "Having completed my MBA in Business Administration, my inclination towards the financial sector led me to a position in a cooperative bank. Seeking a transition to the tech field, a mutual friend recommended LearnTube as the ideal platform for upskilling and acquiring tech skills.\nThe courses, meticulously structured and easily comprehensible, facilitated my learning journey. Within a span of 3 weeks, I successfully completed around 7-8 micro-skills in UI/UX Design. The depth of the course videos and the inclusion of quizzes significantly enhanced my understanding and retention of the material.\nLearnTube's experienced mentors, who are domain experts, conducted weekly sessions, providing me with the opportunity to address any doubts or queries I encountered. I wholeheartedly endorse LearnTube to anyone seeking to upskill and navigate a career transition!",
    videoUrl: "https://youtu.be/vVUpuvHWaz8",
    from: "From Finance",
    to: "Tech in 3 Weeks",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146.png?updatedAt=1706083679906",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(9).png?updatedAt=1706100044811",
  },
  {
    id: 2,
    name: "Fahmida",
    description:
      "My substantial academic development, spanning from the initial year to the ultimate year, owes a considerable portion of its success to the remarkable support I received in upskilling through a platform I stumbled upon on Instagram, known as LearnTube. Delving into their courses, I made the strategic decision to specialize in digital marketing.\nThe LearnTube experience went beyond merely imparting new skills and securing verified certifications; it became a transformative force in bolstering my resume and offering invaluable interview preparation assistance. The comprehensive nature of the courses allowed me to navigate the intricacies of digital marketing with confidence and competence.",
    videoUrl: "https://youtu.be/JfGX8-Z55EE",
    from: "Fresher",
    to: "A Digital Marketind Specialist",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(1).png?updatedAt=1706083773178",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205147.png?updatedAt=1706100149035",
  },
  {
    id: 3,
    name: "Shubham Gaikwad",
    description:
      "As a Computer Engineering student, my aspiration was to explore the realm of Web Development. While I possessed some preliminary knowledge, delving into the courses offered by LearnTube unveiled the vastness of the field. Through LearnTube, I not only obtained certifications in HTML, Java, and CSS but also applied these acquired skills in a practical project. The experienced mentors at LearnTube played a pivotal role in providing guidance, imparting real-world knowledge that transcended the theoretical realm.\nThe exceptional team at LearnTube was consistently supportive, readily available whenever I required assistance. This collaborative environment enhanced my learning experience, fostering a sense of confidence and competence in the intricate domain of Web Development. LearnTube not only equipped me with certifications but also facilitated the practical application of skills, bridging the gap between theoretical understanding and real-world implementation.",
    videoUrl: "https://youtu.be/zQbxAQESw8Y",
    from: "Coputer Engineer",
    to: "An expert Web Developer",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(2).png?updatedAt=1706083884308",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205148.png?updatedAt=1706100206471",
  },
  {
    id: 4,
    name: "Aftab ahmed",
    description:
      "Despite having a masters in aerospace engineering I was always intrigued by the world of artificial intelligence as well as robotics. That's where LearnTube came in.\n I completed various courses on LearnTube related to AI such as data structures & algorithms, python, machine learning and deep learning. I love the fact that they have content from a whole range of tutors, and you can learn from the ones who best suit you.\nSomething I found very useful was the mentorship program, which ensured that I got valuable advice that sped up my preparation. LearnTube also helped me build valuable projects using cutting-edge technology and make me confident to face interviews, and I'm hopeful that I will get into my dream company.",
    videoUrl: "https://youtu.be/nPFIEpK8NKE",
    from: "Pivot from Aersopace engineering",
    to: "AI",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(3).png?updatedAt=1706083986393",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205149.png?updatedAt=1706100257026",
  },
  {
    id: 5,
    name: "Dinesh",
    description:
      "After my graduation, I was on the lookout for internships and full-time jobs when a friend told me about an app called LearnTube. I signed up and started learning various courses such as Computer Fundamentals and some programming languages. The courses were well structured and the videos explained the concepts in depth, which benefited me a lot in enhancing my skills.\nArmed with stronger and better skillsets, I landed an internship at Candere by Kalyan Jewellers with a great stipend. I kept gaining more skills on LearnTube along with my internship. Once my internship was over, I decided to turn my focus towards getting a full time job.\nI started learning some core skills such as Machine Learning and enhancing my CV and profile, all of which led me to crack an excellent job opportunity at Mirae Asset Capital Markets as a Software Developer, with a significant salary bump and great perks!",
    videoUrl: "https://youtube.com/shorts/WU2okGs-fJE?feature=share",
    from: "Graduate",
    to: "Landing an internship at Kalyan Jewlers ",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(4).png?updatedAt=1706084058078",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205150.png?updatedAt=1706100314081",
  },
  {
    id: 6,
    name: "Darshan Deshmukh",
    description:
      "Enrolling in LearnTube initiated my exploration of various Python courses, with a focus on Modules and Packages. Completing these courses significantly enhanced my understanding of Python and its crucial role in data analytics, vital for my ongoing pursuits in this field.\nAddressing challenges or unclear concepts during the learning process became effortless by consulting the experienced mentors on LearnTube. Their guidance played a key role in fortifying my understanding and strengthening foundational concepts.\nAn exceptional feature of these courses is their cost-free nature, ensuring access to valuable learning resources without financial burden. This not only fosters a conducive learning environment but also democratizes education, providing high-quality Python courses to learners without monetary constraints. LearnTube has truly become an invaluable asset in my journey to expertise in Python and data analytics.",
    videoUrl: "https://youtube.com/shorts/iJxXNE5DsVM?feature=share",
    from: "Novice",
    to: "An Expert Data Analyst",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(5).png?updatedAt=1706084101420",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205151.png?updatedAt=1706100362879",
  },
  {
    id: 7,
    name: "Ribhu",
    description:
      "Being a freelancer, I knew that despite having a Masters degree in Mass Communication, I needed to keep updating my skills to have a competitive edge in my career. I started learning Search Engine Marketing on LearnTube to understand the field of SEM in depth and Marketing as a whole and enhance my knowledge.\nThe best part about LearnTube is that they support you through every step of your upskilling journey and help you analyze your progress from start to end and provide insightful tips to boost your learning curve.\nAfter finishing the SEM courses on LearnTube, I have a much deeper understanding about the subject. I am confident in demonstrating my SEM skills to my clients and in the process even gained new clients!",
    videoUrl: "https://youtu.be/pKkerknQF5k",
    from: "Passive freelancing",
    to: "Landing countless clients",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(6).png?updatedAt=1706084153970",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205152.png?updatedAt=1706100433715",
  },
  {
    id: 9,
    name: "Sree Varsha",
    description:
      "Being a computer science and engineering I was always intrigued by the world of Full stack development . That's where LearnTube came in.\nI completed various courses on LearnTube related to Full Stack Development such as data structures & algorithms, Front end development (HTML, CSS, JS and REACT JS) , Backend (MERN) and much more. I love the fact that they have content from a whole range of tutors, and you can learn from the ones who best suit you.\nSomething I found very useful was the mentorship program, which ensured that I got valuable advice that sped up my preparation. LearnTube also helped me build valuable projects using cutting-edge technology and make me confident to face interviews, and I'm hopeful that I will get into my dream company.",
    videoUrl: "https://youtu.be/3vFEJQarDjg",
    from: "Computer Science Engineer",
    to: "A Full Stack Developer",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(7).png?updatedAt=1706084200717",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205153.png?updatedAt=1706100491936",
  },
  {
    id: 10,
    name: "Rupa Shree",
    description:
      "Earning five LearnTube certifications in a month marked the start of my academic journey. The WhatsApp bot amazed me, enabling seamless learning on the go, even amid travel or work. LearnTube's organized courses, with regular quizzes, fortified my understanding and ensured concept retention, boosting confidence in my PGDM studies.\nLearnTube's versatile approach, integrating the WhatsApp bot, made education flexible. The structured curriculum, with interactive quizzes, vitalized my knowledge for PGDM challenges. LearnTube's commitment to enhancing learning was evident, offering a valuable resource that significantly enriched my academic pursuits.",
    videoUrl: "https://youtu.be/KvygfsHoUUE",
    from: "Went from achieveing 5 Certificates a month",
    to: "Aceing her PGDM studies ",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(8).png?updatedAt=1706084293864",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205154.png?updatedAt=1706100529885",
  },
];

export default Constants;
